<template>
	<div id="newQianniu">
		<el-tabs tab-position="left" v-model="tabCurrent" @tab-click="handleClick">
	    <!--第0步 通关必看-->
	    <el-tab-pane name="zero">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">通关必看</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="startvideo" class="startvideo">
					<div class="tip">
						<p><i class="el-icon-video-play"></i></p>
						<p>
							<a class="startstudy" @click="startVideo">开始学习</a>
						</p>
					</div>
				</div>
				<div id="video-zero" class="video-box">
					<video id="zero" src="http://res.study.itaojin.cn/2023-02/2589f33edc9a487fb974cd4968040bb8.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-zero" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="studyNext('#tab-first')">继续下一步学习</a>
						</p>
					</div>
				</div>
	    </el-tab-pane>
	    <!--第1步 Excel界面介绍-->
	    <el-tab-pane name="first">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">1、Excel界面介绍</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
				<div id="video-first" class="video-box">
					<video id="first" src="http://res.study.itaojin.cn/2023-02/5f691afc34024d2da811ff4f6c245131.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-first" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-first" class="content">
					<div class="con-left">
						<!--双击图标-->
						<div v-show="isShowQnIcon" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps1.png" />
							<img class="qnicon01" src="../../../static/workoff/excelimg/dkwps1tb.png" @dblclick="showLoginImg" />
						</div>
						<div v-show="isShowQnIcon2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2.png" />
							<img class="qnicon02 qnicon02-1" src="../../../static/workoff/excelimg/dkwps2-1.png" @mousemove="showLoginImg2" />
							<!-- <img class="qnicon02 qnicon02-1" src="../../../static/workoff/excelimg/dkwps2-1.png" @dblclick="showLoginImg2" /> -->
						</div>
						<div v-show="isShowQnIcon3" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwpx2-2.png" />
							<img class="qnicon02 qnicon02-1" src="../../../static/workoff/excelimg/dkwps2-1.png" @click="showLoginImg3" />

						</div>
						<div v-show="isShowQnIcon4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-3.png" />
							<img class="qnicon02 qnicon04-1" src="../../../static/workoff/excelimg/dkwpstb2.png" @mousemove="showLoginImg4" />
						</div>
						<div v-show="isShowQnIcon5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-4.png" />
							<img class="qnicon02 qnicon05-1" src="../../../static/workoff/excelimg/dkwpstb3.png" @click="showLoginImg5" />
						</div>
						<div v-show="isShowQnIcon6" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-5.png" />
							<img class="qnicon02 qnicon06-1" src="../../../static/workoff/excelimg/dkwpstb4.png" @mousemove="showLoginImg6" />
						</div>
						<div v-show="isShowQnIcon7" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-6.png" />
							<img class="qnicon02 qnicon06-1" src="../../../static/workoff/excelimg/dkwpstb4.png" @click="showLoginImg7" />
						</div>
						<div v-show="isShowQnIcon8" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-7.png" />
							<!-- <img class="qnicon02 qnicon06-1" src="../../../static/workoff/excelimg/dkwpstb4.png" @click="showLoginImg7" /> -->
						</div>
						<div v-show="isShowQnIcon9" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-7.png" />
							<img class="qnicon02 qnicon09-1" src="../../../static/workoff/excelimg/dkwpstb5.png" @click="showLoginImg8" />
						</div>
						<div v-show="isShowQnIcon10" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-8.png" />
							<!-- <img class="qnicon02 qnicon09-1" src="../../../static/workoff/excelimg/dkwpstb5.png" @click="showLoginImg8" /> -->
						</div>
						<div v-show="isShowQnIcon11" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-8.png" />
							<img class="qnicon02 qnicon11-1" src="../../../static/workoff/excelimg/dkwpstb6.png" @click="showLoginImg9" />
						</div>
						<div v-show="isShowQnIcon12" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-9.png"/>
							<!-- <img class="qnicon02 qnicon11-1" src="../../../static/workoff/excelimg/dkwpstb6.png"  /> -->
						</div>
						<div v-show="isShowQnIcon13" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-9.png" />
							<img class="qnicon02 qnicon13-1" src="../../../static/workoff/excelimg/dkwpstb7.png"  @click="showLoginImg10"/>
						</div>
						<div v-show="isShowQnIcon14" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/dkwps2-10.png"/>
							<!-- <img class="qnicon02 qnicon13-1" src="../../../static/workoff/excelimg/dkwpstb7.png"  /> -->
						</div>

					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<!--双击图标-->
						<p v-if="isShowQnIcon">请打开WPS</p>
						<p v-if="isShowQnIcon2 || isShowQnIcon3 || isShowQnIcon4 || isShowQnIcon5 || isShowQnIcon6 || isShowQnIcon7 || isShowQnIcon8">新建一个表格</p>
						<p v-if="isShowQnIcon9 || isShowQnIcon10">选中<span style="color: red;font-weight:bold;">B列</span></p>
						<p v-if="isShowQnIcon11 || isShowQnIcon12">选择<span style="color: red;font-weight:bold;">第6行</span></p>
						<p v-if="isShowQnIcon13 || isShowQnIcon14">选择<span style="color: red;font-weight:bold;">B3单元格</span></p>
						<p v-if="isShowLoginIndex">请进入千牛接待中心</p>
					</div>
				</div>
				<div id="studytip-first" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyFirst"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-second')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>办公软件的功能学习.ppt</p>
								<p>
									<a v-if="isOpenPpt" class="btn-open" @click="viewPpt(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer"></div>
				</div>
	    </el-tab-pane>
	    <!--第2步 Excel内容编辑-->

	    <el-tab-pane name="second">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">2、Excel内容编辑</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="video-second" class="video-box">
					<video id="second" src="http://res.study.itaojin.cn/2023-02/bd934f84a7f94ff08ccb293a3bd739c7.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-second" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-second" class="content">
					<div class="con-left">
						<div class="exclenrbox">
							<div class="qnbox" v-show="isShownr1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-1.png" />
								<img class="nr1-1tb" src="../../../static/workoff/excelimg/nrtb1-1.png" @click="showLoginnr1_1" />
						    </div>
							<div class="qnbox" v-show="isShownr1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-2.png" />
								<input type="text" @keyup.enter="listenOne" v-model="nr_input" ref="strname" class="nr1_2input">
						    </div>
							<div class="qnbox" v-show="isShownr1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-3.png" />
								<img class="nr1-3tb" src="../../../static/workoff/excelimg/nrtb1-1.png" @click="showLoginnr1_3" />

						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-4.png" />
								<input type="text" @keyup.ctrl="listenTwo"  v-model="nr_input2" ref="strname2" class="nr1_4input">

						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-4.png" />
								<input type="text" @keyup.enter="listenTwo_1"  v-model="nr_input2"  class="nr1_4input">

						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_6">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-5.png" />
								<img v-if="isShownr1_6_1" class="nr1-6tb" src="../../../static/workoff/excelimg/nrtb1-6.png" @click="showLoginnr1_6" />

						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_7">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-6.png" />


						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_8">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-7.png" />



						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_9">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-8.png" />

						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_10">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-9.png" />

						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_11">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-10.png" />
								<img class="nr1-11tb" src="../../../static/workoff/excelimg/nrtb1-11.png" @click="showLoginnr1_11" />
						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_12">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-11.png" />
								<img class="nr1-12tb" src="../../../static/workoff/excelimg/nrtb1-12.png" @contextmenu.prevent.stop="rightClick($event)" />
						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_13">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-12.png" />
								<img class="nr1-13tb" src="../../../static/workoff/excelimg/nrtb1-13.png" @mousemove="showLoginnr1_13"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_14">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-13.png" />
								<img class="nr1-14tb" src="../../../static/workoff/excelimg/nrtb1-14.png" @click="showLoginnr1_14"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_15">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-14.png" />
								<!-- <img class="nr1-15tb" src="../../../static/workoff/excelimg/nrtb1-15.png" @click="showLoginnr1_15"/> -->
						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_16">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-15.png" />
								<img class="nr1-15tb" src="../../../static/workoff/excelimg/nrtb1-15.png" @click="showLoginnr1_15"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_17">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-16.png" @contextmenu.prevent.stop='showLoginnr1_16($event)'/>
								<img v-if="isShownr1_17_1" class="nr1-16tb" src="../../../static/workoff/excelimg/nr1-17.png"/>
								<img v-if="isShownr1_17_1" class="nr1-17tb" src="../../../static/workoff/excelimg/nrtb1-16.png" @mousemove="showLoginnr1_17"/>
								<img v-if="isShownr1_17_2" class="nr1-16tb" src="../../../static/workoff/excelimg/nr1-18.png"/>
								<img v-if="isShownr1_17_2" class="nr1-17tb" src="../../../static/workoff/excelimg/nrtb1-17.png" @click="showLoginnr1_17_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShownr1_18">
								<img class="qnbg" src="../../../static/workoff/excelimg/nr1-19.png" />

						    </div>

							<!-- 求和 -->
							<div class="qnbox nr1_4" v-show="isShownr1_19">
								<img class="qnbg" src="../../../static/workoff/excelimg/qh1-1.png" />
							    <img class="nr1-19tb" src="../../../static/workoff/excelimg/nrtb1-1.png"  @click="showLoginnr1_19"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowqh1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/qh1-2.png" />
								<input type="text"   v-model="qh1_input" ref="strname_1qh"  class="qh1_1input">
								<img class="qh1-1tb" src="../../../static/workoff/excelimg/qhtb1-1.png"  @click="showLoginnr1_20"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowqh1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/qh1-3.png" />
								<input type="text"   v-model="qh1_input1" ref="strname_2qh"  class="qh1_1input">
								 <img class="qh1-2tb" src="../../../static/workoff/excelimg/qhtb1-2.png"  @click="showLoginqh1_2"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowqh1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/qh1-4.png" />
								<input type="text"   v-model="qh1_input" ref="strname_1qh"  class="qh1_1input">
								 <img class="qh1-3tb" src="../../../static/workoff/excelimg/qhtb1-3.png"  @click="showLoginqh1_3"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowqh1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/qh1-5.png" />


						    </div>
							<div class="qnbox nr1_4" v-show="isShowqh1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/qh1-6.png"/>
						    </div>

							<!-- 平均 -->
							<div class="qnbox nr1_4" v-show="isShowpj1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/pj1-1.png"/>
								 <img class="pjtb1-1" src="../../../static/workoff/excelimg/nrtb1-1.png"  @click="Loginpj1_1"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowpj1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/pj1-2.png"/>
								<input type="text"   v-model="pj1_input" ref="strname_pj1"  class="pj1_1input">
								<img class="pjtb1-2" src="../../../static/workoff/excelimg/pjtb1-1.png"  @click="Loginpj1_2"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowpj1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/pj1-3.png"/>
								<input type="text"   v-model="pj1_input" ref="strname_pj1"  class="pj1_1input">
								<!-- <input type="text" @keyup.enter="showLoginpj1_1"  v-model="pj_input1" ref="strname_pj1"  class="pj1_1input"> -->
								 <!-- <img class="pjtb1-2" src="../../../static/workoff/excelimg/pjtb1-1.png"  @click="Loginpj1_1"/> -->

						    </div>
							<div class="qnbox nr1_4" v-show="isShowpj1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/pj1-4.png"/>


						    </div>

							<!-- 总分 -->
							<div class="qnbox nr1_4" v-show="isShowzf1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/zf1-1.png"/>

								<img class="zftb1-1" src="../../../static/workoff/excelimg/dkwpstb7.png"  @click="Loginzf1_1"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzf1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/zf1-2.png"/>
								<input type="text"   v-model="zf1_input" ref="strname_zf1"  class="zf1_1input">
								<img class="pjtb1-2" src="../../../static/workoff/excelimg/pjtb1-1.png"  @click="Loginzf1_2"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzf1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/zf1-3.png"/>
								<input type="text"   v-model="zf1_input" ref="strname_zf1"  class="zf1_1input">
								<img class="zftb1-2" src="../../../static/workoff/excelimg/zftb1-1.png"  @click="Loginzf1_3"/>
								<!-- <img class="zftb1-1" src="../../../static/workoff/excelimg/dkwpstb7.png"  @click="Loginpj1_2"/> -->

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzf1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/zf1-4.png"/>
								<!-- <input type="text" @keyup.enter="showLoginzf1_1"  v-model="zf_input1" ref="strname_zf1"  class="zf1_1input"> -->

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzf1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/zf1-5.png"/>
						    </div>

							<!-- 修改 -->
							<div class="qnbox nr1_4" v-show="isShowxg1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/xg1-1.png"/>
								<img class="xgtb1-1" src="../../../static/workoff/excelimg/xgtb1-1.png"  @click="Loginxg1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxg1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/xg1-2.png"/>
								<input type="text" @keyup.enter="showLoginxg1_1"  v-model="xg_input1" ref="strname_xg1"  class="xg1_1input">
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxg1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/xg1-3.png"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowxj1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/xj1-1.png"/>
								<img class="xjtb1-1" src="../../../static/workoff/excelimg/xjtb1-1.png"  @mousemove="Loginxj1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxj1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/xj1-2.png"/>
								<img class="xjtb1-2" src="../../../static/workoff/excelimg/xjtb1-2.png"  @click="Loginxj1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxj1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/xj1-3.png"/>

						    </div>

							<!-- 占比 -->
							<div class="qnbox nr1_4" v-show="isShowzb1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/zb1-1.png"/>
								<img class="qnicon02 zbtb1-1" src="../../../static/workoff/excelimg/dkwpstb7.png"  @click="Loginzb1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzb1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/zb1-2.png"/>
								<input type="text" v-model="zb_input1" ref="strname_zb1"  class="zb1_1input">
								<img class="zbtb1-2" src="../../../static/workoff/excelimg/zbtb1-1.png"  @click="Loginzb1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzb1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/zb1-3.png"/>
								<input type="text" v-model="zb_input1" ref="strname_zb1"  class="zb1_1input">
								<img class="zbtb1-3" src="../../../static/workoff/excelimg/zbtb1-2.png"  @click="Loginzb1_3"/>
								<!-- <img class="qnicon02 zbtb1-1" src="../../../static/workoff/excelimg/dkwpstb7.png"  @click="Loginzb1_1"/> -->

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzb1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/zb1-4.png"/>
								<!-- <input type="text" @keyup.enter="showLoginzb1_1"  v-model="zb_input1" ref="strname_zb1"  class="zb1_1input"> -->

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzb1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/zb1-5.png"/>


						    </div>
							<!-- 修改第二个表单 -->
							<div class="qnbox nr1_4" v-show="isShowxg2_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/xg2-1.png"/>
								<img class="xgtb2-1" src="../../../static/workoff/excelimg/xgtb2-1.png"  @click="Loginxg2_1"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowxg2_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/xg2-2.png"/>
								<input type="text" @keyup.enter="showLoginxg2_1"  v-model="xg_input2" ref="strname_xg2"  class="xg2_1input">
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxg2_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/xg2-3.png"/>

						    </div>
						</div>

					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="(isShownr1_1 && isShownr1_3_1==false) || (isShownr1_2 && isShownr1_3_1==false) || (isShownr1_3 && isShownr1_3_1==false)">在<span style="color: red;font-weight:bold;">J2</span>单元格输入<span style="color: red;font-weight:bold;">总分较8月上升（下降）</span>并按<span style="color: red;font-weight:bold;">Enter键</span>确定
						<p v-if="isShownr1_3 && isShownr1_3_1 || isShownr1_4 || isShownr1_5 || (isShownr1_6 && isShownr1_6_1==false)">在<span style="color: red;font-weight:bold;">A3</span>单元格先使用<span style="color: red;font-weight:bold;">快捷键</span>的方式录入当前日期，再将日期修改为<span style="color: red;font-weight:bold;">2022/9/29</span></p>
						<p v-if="(isShownr1_6 && isShownr1_6_1) || isShownr1_7 || isShownr1_8 || isShownr1_9 || isShownr1_9"><span style="color: red;font-weight:bold;">使用复制快捷键</span>复制<span style="color: red;font-weight:bold;">A3</span>单元格日期，<span style="color: red;font-weight:bold;">使用粘贴快捷键</span>粘贴日期</p>
						<p v-if="isShownr1_11 || isShownr1_12 || isShownr1_13 || isShownr1_14 || isShownr1_15">在<span style="color: red;font-weight:bold;">姓名列右侧</span>插入一列</p>
						<p v-if="isShownr1_16 || isShownr1_17 || isShownr1_18">在<span style="color: red;font-weight:bold;">第6行上方</span>插入一行</p>
						<p v-if="isShownr1_19 || isShowqh1_1 || isShowqh1_2 || isShowqh1_3 || isShowqh1_4 || isShowqh1_5">在<span style="color: red;font-weight:bold;">I3</span>单元格中，采用<span style="color: red;font-weight:bold;">单元格相加</span>的方式计算9月总分</p>
						<p v-if="isShowpj1_1 || isShowpj1_2 || isShowpj1_3 || isShowpj1_4">在<span style="color: red;font-weight:bold;">J3</span>单元格中，采用<span style="color: red;font-weight:bold;">单元格相除</span>的方式计算平均分</p>
						<p v-if="isShowzf1_1 || isShowzf1_2 || isShowzf1_3 || isShowzf1_4 || isShowzf1_5">在<span style="color: red;font-weight:bold;">K3</span>单元格中，采用<span style="color: red;font-weight:bold;">单元格相减</span>的方式计算总分较8月上升（下降）</p>
						<p v-if="isShowxg1_1 || isShowxg1_2 || isShowxg1_3">将工作表<span style="color: red;font-weight:bold;">Sheet1</span>名称修改为<span style="color: red;font-weight:bold;">成绩汇总</span>并按<span style="color: red;font-weight:bold;">Enter键</span>确定</p>
						<p v-if="isShowxj1_1 || isShowxj1_2 || isShowxj1_3">新建一个<span style="color: red;font-weight:bold;">工作表</span></p>
						<p v-if="isShowzb1_1 || isShowzb1_2 || isShowzb1_3 || isShowzb1_4 || isShowzb1_5">在<span style="color: red;font-weight:bold;">C3</span>单元格中计算290分及以上的人数<span style="color: red;font-weight:bold;">在总人数中的占比</span></p>
						<p v-if="isShowxg2_1 || isShowxg2_2 || isShowxg2_3">将工作表<span style="color: red;font-weight:bold;">Sheet2</span>名称修改为<span style="color: red;font-weight:bold;">数据统计</span>并按<span style="color: red;font-weight:bold;">Enter键</span>确定</p>
					</div>
				</div>
				<div id="studytip-second" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudySecond"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-third')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>办公软件的功能学习.ppt</p>
								<p>
									<a v-if="isOpenPpt2" class="btn-open" @click="viewPpt2(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt2">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer2"></div>
				</div>
	    </el-tab-pane>
	    <!--第3步 Excel内容布局-->

	     <el-tab-pane name="third">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">3、Excel内容布局</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="video-third" class="video-box">
					<video id="third" src="http://res.study.itaojin.cn/2023-02/3f087b31498b48479e7249cfa12ef8dd.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-third" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-third" class="content">
					<div class="con-left">
						<!--Excel内容布局 -->
						<div class="exclenrbox">
							<!-- 字体 -->
							<div class="qnbox nr1_4" v-show="isShowzt1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zt1-1.png"/>
							    <img class="zttb1-1" src="../../../static/workoff/excelimg/layout/zttb1-1.png"  @mousemove="Loginzt1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzt1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zt1-2.png"/>
								 <img class="zttb1-1" src="../../../static/workoff/excelimg/layout/zttb1-1.png"  @click="Loginzt1_2"/>
							    <!-- <img class="zttb1-1" src="../../../static/workoff/excelimg/layout/zttb1-1.png"  @click="Loginzt1_1"/> -->
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzt1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zt1-3.png"/>
								<img class="zttb1-2" src="../../../static/workoff/excelimg/layout/zttb1-2.png"  @mousemove="Loginzt1_3"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzt1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zt1-4.png"/>
								<img class="zttb1-3" src="../../../static/workoff/excelimg/layout/zttb1-3.png"  @click="Loginzt1_4"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowzt1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zt1-5.png"/>
								<!-- <img class="zttb1-3" src="../../../static/workoff/excelimg/layout/zttb1-3.png"  @click="Loginzt1_4"/> -->

						    </div>
							<!-- 居中 -->
							<div class="qnbox nr1_4" v-show="isShowjz1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zt1-5.png"/>
								<img class="jztb1-1" src="../../../static/workoff/excelimg/layout/jztb1-1.png"  @mousemove="Loginjz1_1"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjz1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jz1-1.png"/>
								<img class="jztb1-2" src="../../../static/workoff/excelimg/layout/jztb1-2.png"  @click="Loginjz1_2"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjz1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jz1-2.png"/>
								<!-- <img class="jztb1-1" src="../../../static/workoff/excelimg/layout/jztb1-1.png"  @click="Loginjz1_1"/> -->

						    </div>
							<!-- 框线 -->
							<div class="qnbox nr1_4" v-show="isShowkx1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jz1-2.png"/>
								<img class="kxtb1-1" src="../../../static/workoff/excelimg/layout/kxtb1-1 (2).png"  @mousemove="Loginkx1_1"/>
								<!-- <img class="jztb1-1" src="../../../static/workoff/excelimg/layout/jztb1-1.png"  @click="Loginjz1_1"/> -->

						    </div>
							<div class="qnbox nr1_4" v-show="isShowkx1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/kx1-1.png"/>
								<img class="kxtb1-2" src="../../../static/workoff/excelimg/layout/kxtb1-2.png"  @click="Loginkx1_2"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowkx1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/kx1-2.png"/>
								<img class="kxtb1-3" src="../../../static/workoff/excelimg/layout/kxtb1-3.png"  @mousemove="Loginkx1_3"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowkx1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/kx1-3.png"/>
								<img class="kxtb1-4" src="../../../static/workoff/excelimg/layout/kxtb1-4.png"  @click="Loginkx1_4"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowkx1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/kx1-4.png"/>
								<!-- <img class="kxtb1-4" src="../../../static/workoff/excelimg/layout/kxtb1-4.png"  @click="Loginkx1_4"/> -->

						    </div>
							<!-- 调A列 -->
							<!-- <div class="qnbox nr1_4" v-show="isShowta1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/kx1-4.png"/>
								<img class="tatb1-1" src="../../../static/workoff/excelimg/layout/tatb1-1.png"  @click="Loginta1_1"/>

						    </div> -->
							<div class="qnbox nr1_4" v-show="isShowta1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/ta1-1.png"/>
								<img class="tatb1-2" src="../../../static/workoff/excelimg/layout/tatb1-3.png" @dblclick="Loginta1_2"/>
<!--                <span class="dbclick" @dblclick.prevent="Loginta1_2($event)"></span>-->

                <img class="dbclick" src="./bg.png" alt="" srcset="" @dblclick="Loginta1_2">
						    </div>
							<div class="qnbox nr1_4" v-show="isShowta1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/ta1-3.png"/>


						    </div>
							<!-- 加粗合并第一行 -->
							<div class="qnbox nr1_4" v-show="isShowjchb1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-1.png"/>
								<img class="jchbtb1-1" src="../../../static/workoff/excelimg/layout/jchbtb1-1.png"  @mousemove="Loginjchb1_1"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-2.png"/>
								<img class="jchbtb1-2" src="../../../static/workoff/excelimg/layout/jchbtb1-2.png"  @click="Loginjchb1_2"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-3.png"/>
								<img class="jchbtb1-2" src="../../../static/workoff/excelimg/layout/jchbtb1-2.png"  @click="Loginjchb1_3"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-4.png"/>
								<img class="jchbtb1-4" src="../../../static/workoff/excelimg/layout/jchbtb1-2-1.png"  @mousemove="Loginjchb1_4"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-5.png"/>
								<img class="jchbtb1-5" src="../../../static/workoff/excelimg/layout/jchbtb1-3.png"  @click="Loginjchb1_5"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_6">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-6.png"/>
								<img class="jchbtb1-6" src="../../../static/workoff/excelimg/layout/jchbtb1-4.png"  @mousemove="Loginjchb1_6"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_7">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-7.png"/>
								<img class="jchbtb1-7" src="../../../static/workoff/excelimg/layout/jchbtb1-5.png"  @click="Loginjchb1_7"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_8">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-8.png"/>
								<img class="jchbtb1-8" src="../../../static/workoff/excelimg/layout/jchbtb1-6.png"  @mousemove="Loginjchb1_8"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_9">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-9.png"/>
								<img class="jchbtb1-9" src="../../../static/workoff/excelimg/layout/jchbtb1-7.png"  @click="Loginjchb1_9"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_10">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-10.png"/>
								<img class="jchbtb1-10" src="../../../static/workoff/excelimg/layout/jchbtb1-8.png"  @mousemove="Loginjchb1_10"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_11">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-11.png"/>
								<img class="jchbtb1-11" src="../../../static/workoff/excelimg/layout/jchbtb1-8.png"  @click="Loginjchb1_11"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowjchb1_12">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/jchb1-12.png"/>
								<!-- <img class="jchbtb1-10" src="../../../static/workoff/excelimg/layout/jchbtb1-8.png"  @click="Loginjchb1_11"/> -->

						    </div>
							<!-- 颜色换行第二行 -->
							<div class="qnbox nr1_4" v-show="isShowyshh1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/yshh1-2.png"/>
								<img class="yshhtb1-1" src="../../../static/workoff/excelimg/layout/yshhtb1-1.png"  @mousemove="Loginyshh1_1"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowyshh1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/yshh1-3.png"/>
								<img class="yshhtb1-2" src="../../../static/workoff/excelimg/layout/yshhtb1-2.png"  @click="Loginyshh1_2"/>


						    </div>
							<div class="qnbox nr1_4" v-show="isShowyshh1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/yshh1-3-1.png"/>
								<img class="yshhtb1-3" src="../../../static/workoff/excelimg/layout/yshhtb1-3.png"  @mousemove="Loginyshh1_3"/>


						    </div>
							<div class="qnbox nr1_4" v-show="isShowyshh1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/yshh1-3-2.jpg"/>
								<img class="yshhtb1-4" src="../../../static/workoff/excelimg/layout/yshhtb1-4.png"  @click="Loginyshh1_4"/>


						    </div>
							<!-- <div class="qnbox nr1_4" v-show="isShowyshh1_4_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/yshh1-3-2.jpg"/>
								<img class="yshhtb1-4" src="../../../static/workoff/excelimg/layout/yshhtb1-4.png"  @click="Loginyshh1_4"/>


						    </div> -->
							<div class="qnbox nr1_4" v-show="isShowyshh1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/yshh1-7.png"/>



						    </div>
							<!-- 冻结 -->
							<div class="qnbox nr1_4" v-show="isShowdj1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/dj1-1.png"/>
								<img class="djtb1-1" src="../../../static/workoff/excelimg/layout/djtb1-1.png"  @mousemove="Logindj1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowdj1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/dj1-2.png"/>
								<img class="djtb1-2" src="../../../static/workoff/excelimg/layout/djtb1-2.png"  @click="Logindj1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowdj1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/dj1-3.png"/>
								<img class="djtb1-3" src="../../../static/workoff/excelimg/layout/djtb1-3.png"  @mousemove="Logindj1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowdj1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/dj1-4.png"/>
								<img class="djtb1-4" src="../../../static/workoff/excelimg/layout/djtb1-4.png"  @click="Logindj1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowdj1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/dj1-5.png"/>
						    </div>
							<!-- 保留小数 -->
							<div class="qnbox nr1_4" v-show="isShowxs1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-1.png"/>
								<img class="xstb1-1" src="../../../static/workoff/excelimg/layout/xstb1-1.png"  @mousemove="Loginxs1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-2.png"/>
								<img class="xstb1-2" src="../../../static/workoff/excelimg/layout/xstb1-2.png"  @click="Loginxs1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-3.png"/>
								<img class="xstb1-3" src="../../../static/workoff/excelimg/layout/xstb1-3.png"  @mousemove="Loginxs1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-4.png"/>
								<img class="xstb1-4" src="../../../static/workoff/excelimg/layout/xstb1-4.png"  @click="Loginxs1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-5.png"/>
								<img class="xstb1-5" src="../../../static/workoff/excelimg/layout/xstb1-5.png"  @click="Loginxs1_5"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_6">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-6.png"/>
								<img class="xstb1-6" src="../../../static/workoff/excelimg/layout/xstb1-6.png"  @mousemove="Loginxs1_6"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_7">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-7.png"/>
								<img class="xstb1-7" src="../../../static/workoff/excelimg/layout/xstb1-7.png"  @click="Loginxs1_7"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_8">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-8.png"/>
								<img class="xstb1-8" src="../../../static/workoff/excelimg/layout/xstb1-8.png"  @mousemove="Loginxs1_8"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_9">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-9.png"/>
								<img class="xstb1-9" src="../../../static/workoff/excelimg/layout/xstb1-9.png"  @click="Loginxs1_9"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowxs1_10">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/xs1-10.png"/>

						    </div>
							<!-- 占比保留两位小数 -->
							<div class="qnbox nr1_4" v-show="isShowzbbl1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zbbl1-1.png"/>
								<img class="zbbltb1-1" src="../../../static/workoff/excelimg/layout/xstb1-1.png"  @mousemove="Loginzbbl1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzbbl1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zbbl1-2.png"/>
								<img class="zbbltb1-2" src="../../../static/workoff/excelimg/layout/xstb1-2.png"  @click="Loginzbbl1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzbbl1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zbbl1-3.png"/>
								<img class="zbbltb1-3" src="../../../static/workoff/excelimg/layout/zbbltb1-1.png"  @mousemove="Loginzbbl1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzbbl1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zbbl1-4.png"/>
								<img class="zbbltb1-4" src="../../../static/workoff/excelimg/layout/zbbltb1-2.png"  @click="Loginzbbl1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowzbbl1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/layout/zbbl1-5.png"/>
						    </div>

						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="isShowzt1_1 || isShowzt1_2 || isShowzt1_3 || isShowzt1_4 || isShowzt1_5">请将字体设置为<span style="color: red;font-weight:bold;">微软雅黑</span></p>
						<p v-if="isShowjz1_1 || isShowjz1_2 || isShowjz1_3">将内容<span style="color: red;font-weight:bold;">水平居中</span></p>
						<p v-if="isShowkx1_1 || isShowkx1_2 || isShowkx1_3 || isShowkx1_4 || isShowkx1_5">将框线设置为<span style="color: red;font-weight:bold;">所有框线</span></p>
						<p v-if="isShowta1_2 || isShowta1_3">补充知识:<br>请采用<span style="color: red;font-weight:bold;">双击鼠标</span>的方式调整<span style="color: red;font-weight:bold;">A列</span>宽度</p>
						<p v-if="isShowjchb1_1 || isShowjchb1_2 || isShowjchb1_3 || isShowjchb1_4 || isShowjchb1_5 || isShowjchb1_6 || isShowjchb1_7 || isShowjchb1_8 || isShowjchb1_9 || isShowjchb1_10 || isShowjchb1_11 || isShowjchb1_12">1、将<span style="color: red;font-weight:bold;">第1行</span>字号大小<span style="color: red;font-weight:bold;">逐步加大到14号</span><br>2、<span style="color: red;font-weight:bold;">字体加粗</span>；<br>3、合并<span style="color: red;font-weight:bold;">A1-K1</span>单元格；<br>4、将背景填充为<span style="color: red;font-weight:bold;">浅蓝色</span>（第二行倒数第二个颜色）</p>
						<p v-if="isShowyshh1_1 || isShowyshh1_2">1、将<span style="color: red;font-weight:bold;">I2-K2</span>字体设置为<span style="color: red;font-weight:bold;">红色</span></p>
						<p v-if="isShowyshh1_3 || isShowyshh1_4 || isShowyshh1_5">2、将<span style="color: red;font-weight:bold;">K2</span>单元格内的内容<span style="color: red;font-weight:bold;">自动换行</span></p>
						<p v-if="isShowdj1_1 || isShowdj1_2 || isShowdj1_3 || isShowdj1_4 || isShowdj1_5"><span style="color: red;font-weight:bold;">冻结</span>第<span style="color: red;font-weight:bold;">1</span>行和第<span style="color: red;font-weight:bold;">2</span>行</p>
						<p v-if="isShowxs1_1 || isShowxs1_2 || isShowxs1_3 ||isShowxs1_4 || isShowxs1_5 || isShowxs1_6 || isShowxs1_7 || isShowxs1_8 || isShowxs1_9 || isShowxs1_10 ">将平均分设置为<span style="color: red;font-weight:bold;">1位小数</span></p>
						<p v-if="isShowzbbl1_1 || isShowzbbl1_2 || isShowzbbl1_3 || isShowzbbl1_4 || isShowzbbl1_5"><span style="color: red;font-weight:bold;">占比</span>用<span style="color: red;font-weight:bold;">百分比</span>表示，保留2位小数</p>
					</div>
				</div>
				<div id="studytip-third" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyThird"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-four')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>办公软件的功能学习.ppt</p>
								<p>
									<a v-if="isOpenPpt3" class="btn-open" @click="viewPpt3(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt3">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer3"></div>
				</div>
	    </el-tab-pane>
	 <!-- 第四步 保存文件 -->
	    <el-tab-pane name="four">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">4、保存文件</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="video-four" class="video-box">
					<video id="four" src="http://res.study.itaojin.cn/2023-02/1811f87020ab466db890f5b601f915be.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-four" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-four" class="content">
					<div class="con-left">
						<div class="exclenrbox">
							<div class="qnbox nr1_4" v-show="isShowbc1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-1.png"/>
								<!-- <input type="text" @keyup.ctrl="showLoginbc1_1"  v-model="bc_input1" ref="strname_bc1"  class="bc1_1input"> -->
						    </div>
							<div class="qnbox nr1_4" v-show="isShowbc1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-2.png"/>
								<img class="bctb1-1" src="../../../static/workoff/excelimg/SaveFile/bctb1-1.png"  @mousemove="Loginbc1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowbc1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-3.png"/>
								<img class="bctb1-2" src="../../../static/workoff/excelimg/SaveFile/bctb1-2.png"  @click="Loginbc1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowbc1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-4.png"/>
								<img class="bctb1-3" src="../../../static/workoff/excelimg/SaveFile/bctb1-3.png"  @mousemove="Loginbc1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowbc1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-5.png"/>
								<img class="bctb1-4" src="../../../static/workoff/excelimg/SaveFile/bctb1-4.png"  @dblclick="Loginbc1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowbc1_6">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-6.png"/>
								<img class="bctb1-5" src="../../../static/workoff/excelimg/SaveFile/bctb1-5.png"  @click="Loginbc1_5"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowbc1_7">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-7.png"/>
								<img class="bctb1-6" src="../../../static/workoff/excelimg/SaveFile/bctb1-6.png"  @click="Loginbc1_6"/>
						    </div>
							<div class="qnbox nr1_4 inputlength" v-show="isShowbc1_8">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-8.png"/>
								<input type="text"   v-model="bc_input2" ref="strname_bc2" class="bc_2input">
								<img class="bctb1-7" src="../../../static/workoff/excelimg/SaveFile/bctb1-7.png"  @click="Loginbc1_7"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowbc1_9">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-9.png"/>

						    </div>

							<!-- 另存为 -->
							<div class="qnbox nr1_4" v-show="isShowlc1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-9.png" @contextmenu.prevent.stop="Loginlc1_1($event)"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowlc1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-9.png"/>
								<img class="lc1-1" src="../../../static/workoff/excelimg/SaveFile/lc1-1.png"/>
								<img class="lctb1-1" src="../../../static/workoff/excelimg/SaveFile/lctb1-1.png"  @mousemove="Loginlc1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowlc1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-9.png"/>
								<img class="lc1-1" src="../../../static/workoff/excelimg/SaveFile/lc1-2.png"/>
								<img class="lctb1-2" src="../../../static/workoff/excelimg/SaveFile/lctb1-2.png"  @click="Loginlc1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowlc1_4">
								<img class="lc1-2" src="../../../static/workoff/excelimg/SaveFile/lc1-3.png"/>
								<img class="lctb1-3" src="../../../static/workoff/excelimg/SaveFile/lctb1-3.png"  @mousemove="Loginlc1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowlc1_5">
								<img class="lc1-2" src="../../../static/workoff/excelimg/SaveFile/lc1-4.png"/>
								<img class="lctb1-4" src="../../../static/workoff/excelimg/SaveFile/bctb1-2.png"  @click="Loginlc1_5"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowlc1_6">
								<img class="lc1-2" src="../../../static/workoff/excelimg/SaveFile/lc1-5.png"/>
								<img class="lctb1-5" src="../../../static/workoff/excelimg/SaveFile/bctb1-7.png"  @click="Loginlc1_6"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowlc1_7">
								<img class="lc1-2" src="../../../static/workoff/excelimg/SaveFile/bc1-9.png"/>
						    </div>


						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if='isShowbc1_1'>使用<span style="color: red;font-weight:bold;">快捷键</span>打开文件保存路径，将表格保存到<span style="color: red;font-weight:bold;">桌面</span>的<span style="color: red;font-weight:bold;">办公软件培训</span>文件夹中，并将<span style="color: red;font-weight:bold;">文件名称</span>修改为<span style="color: red;font-weight:bold;">月考成绩统计</span></p>
						<p v-if='isShowbc1_2|| isShowbc1_3 '>选择<span style="color: red;font-weight:bold;">我的桌面</span></p>
						<p v-if='isShowbc1_4 || isShowbc1_5 '>鼠标左键<span style="color: red;font-weight:bold;">双击办公软件培训</span>，打开文件夹</p>
						<p v-if='isShowbc1_6 || isShowbc1_7 || isShowbc1_8  || isShowbc1_9'>将<span style="color: red;font-weight:bold;">文件名</span>修改为<span style="color: red;font-weight:bold;">月考成绩统计，并点击保存</span></p>
						<p v-if='isShowlc1_1 || isShowlc1_2 ||isShowlc1_3 || isShowlc1_4 || isShowlc1_5 || isShowlc1_6 || isShowlc1_7'>将文件另存到<span style="color: red;font-weight:bold;">桌面</span></p>
					</div>


				</div>
				<div id="studytip-four" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyFour"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-five')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>办公软件的功能学习.ppt</p>
								<p>
									<a v-if="isOpenPpt4" class="btn-open" @click="viewPpt4(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt4">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer4"></div>
				</div>
	    </el-tab-pane>
	    <!--第5步 发送文件-->
	    <el-tab-pane name="five">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">5、发送文件</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="video-five" class="video-box">
					<video id="five" src="http://res.study.itaojin.cn/2023-02/78ceee7e08034c37a419140a8a5298a0.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-five" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-five" class="content">
					<div class="con-left">
						<div class="exclenrbox">
							<!-- 发送文件 -->
							<div class="qnbox nr1_4" v-show="isShowfs1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/bc1-9.png"/>
								<img class="fstb1-0" src="../../../static/workoff/excelimg/SaveFile/fstb1-3.png"  @mousemove="Loginfs1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowfs1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/fs1-1.png"/>
								<img class="fstb1-1" src="../../../static/workoff/excelimg/SaveFile/fstb1-1.png"  @click="Loginfs1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowfs1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/fs1-2.png"/>
								<img class="fstb1-2" src="../../../static/workoff/excelimg/SaveFile/fstb1-2.png"  @click="Loginfs1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowfs1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/fs1-3.png"/>
								<!-- <img class="fstb1-2" src="../../../static/workoff/excelimg/SaveFile/fstb1-2.png"  @click="Loginfs1_3"/> -->
						    </div>
							<div class="qnbox nr1_4" v-show="isShowfs1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/fs1-4.png"/>
								<!-- <img class="fstb1-2" src="../../../static/workoff/excelimg/SaveFile/fstb1-2.png"  @click="Loginfs1_3"/> -->
						    </div>
							<div class="qnbox nr1_4" v-show="isShowfs1_6">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/fs1-5.png"/>
								<img class="fstb1-3" src="../../../static/workoff/excelimg/SaveFile/fstb1-4.png"  @click="Loginfs1_6"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowfs1_7">
								<img class="qnbg" src="../../../static/workoff/excelimg/SaveFile/fs1-6.png"/>
								<!-- <img class="fstb1-3" src="../../../static/workoff/excelimg/SaveFile/fstb1-4.png"  @click="Loginfs1_6"/> -->
						    </div>
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="isShowfs1_1 || isShowfs1_2 || isShowfs1_3 || isShowfs1_4 || isShowfs1_5 || isShowfs1_6 || isShowfs1_7">1、关闭表格;<br/>2、使用<span style="color: red;font-weight:bold;">复制快捷键</span>复制表格;<br/>3、使用<span style="color: red;font-weight:bold;">粘贴快捷键</span>粘贴表格到QQ群，并发送</p>

					</div>
				</div>
				<div id="studytip-five" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<!-- <p>你已完成Excel的功能学习，<br>接下来请完成《Excel实操》。</p> -->
						<p>
							<a class="restart" @click="restartStudyFive"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-six')">GO，下一关</a>
						</p>
						 <!-- <a class="startstudy" href="/tjkStudy/simulate/newqianniuexam" style="width: 160px;">去完成Excel模拟实操</a> -->
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>办公软件的功能学习.ppt</p>
								<p>
									<a v-if="isOpenPpt5" class="btn-open" @click="viewPpt5(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt5">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer5"></div>
				</div>
	    </el-tab-pane>
	     <!--第6步 Word基础功能-->
	    <el-tab-pane name="six">
	    	<div slot="label" class="tab-slot">
	    		<p class="title">6、Word基础功能</p>
	    		<div class="hover-con">
		    		<p><i class="el-icon-video-play"></i></p>
		    		<p>点击学习</p>
	    		</div>
	    	</div>
	    	<div id="video-six" class="video-box">
					<video id="six" src="http://res.study.itaojin.cn/2023-02/0671010263394b0993b576b5ff316603.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-six" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-six" class="content">
					<div class="con-left">
						<div class="exclenrbox">
							<div class="qnbox nr1_4" v-show="isShowwdzt1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-1.png"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-2.png"/>
							 	<img class="zttb1-1" src="../../../static/workoff/excelimg/layout/zttb1-1.png"  @mousemove="Loginwdzt1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-3.png"/>
								<img class="wdzttb1-2" src="../../../static/workoff/excelimg/word/wdzttb1-1.png"  @click="Loginwdzt1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-4.png"/>
								<img class="wdzttb1-3" src="../../../static/workoff/excelimg/word/wdzttb1-2.png"  @mousemove="Loginwdzt1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-5.png"/>
								<img class="wdzttb1-4" src="../../../static/workoff/excelimg/word/wdzttb1-3.png"  @click="Loginwdzt1_5"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_6">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-6.png"/>
								<img class="wdzttb1-5" src="../../../static/workoff/excelimg/layout/zttb1-1.png"  @mousemove="Loginwdzt1_6"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_7">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-7.png"/>
								<img class="wdzttb1-6" src="../../../static/workoff/excelimg/word/wdzttb1-1.png"  @click="Loginwdzt1_7"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_8">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-8.png"/>
								<img class="wdzttb1-7" src="../../../static/workoff/excelimg/word/wdzttb1-4.png"  @mousemove="Loginwdzt1_8"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_9">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-9.png"/>
								<img class="wdzttb1-8" src="../../../static/workoff/excelimg/word/wdzttb1-5.png"  @click="Loginwdzt1_9"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdzt1_10">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-10.png"/>

						    </div>
							<!-- 行距 -->
							<div class="qnbox nr1_4" v-show="isShowwdhj1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdzt1-10.png"/>
								<img class="wdhjtb1-1" src="../../../static/workoff/excelimg/word/wdhjtb1-1.png"  @mousemove="Loginwdhj1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdhj1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdhj1-1.png"/>
								<img class="wdhjtb1-2" src="../../../static/workoff/excelimg/word/wdhjtb1-2.png"  @click="Loginwdhj1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdhj1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdhj1-2.png"/>
								<img class="wdhjtb1-3" src="../../../static/workoff/excelimg/word/wdhjtb1-3.png"  @mousemove="Loginwdhj1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdhj1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdhj1-3.png"/>
								<img class="wdhjtb1-4" src="../../../static/workoff/excelimg/word/wdhjtb1-4.png"  @click="Loginwdhj1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdhj1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdhj1-4.png"/>

						    </div>
							<!-- 首行缩进 -->
							<div class="qnbox nr1_4" v-show="isShowwdsj1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdsj1-1.png" @contextmenu.prevent.stop="rightClick_sj($event)"/>
								<img v-if="isShowwdsj1_1_1" class="wdsjtb1-1" src="../../../static/workoff/excelimg/word/wdsjtb1-1.png"/>
								<img v-if="isShowwdsj1_1_1" class="wdsjtb1-1-1" src="../../../static/workoff/excelimg/word/wdsjtb1-1-1.png" @mousemove="Loginwdsj1_1" />

						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdsj1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdsj1-1.png"/>
								<img class="wdsjtb1-1" src="../../../static/workoff/excelimg/word/wdsjtb1-1.png"/>
								<img  class="wdsjtb1-1-1" src="../../../static/workoff/excelimg/word/wdsjtb1-2.png" @click="Loginwdsj1_2"/>

						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdsj1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdsj1-1.png"/>
								<img class="wdsjtb1-2" src="../../../static/workoff/excelimg/word/wdsjtb1-3.png"/>
								<img class="wdsjtb1-3" src="../../../static/workoff/excelimg/word/wdsjtb1-3-1.png" @click="Loginwdsj1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdsj1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdsj1-1.png"/>
								<img class="wdsjtb1-2" src="../../../static/workoff/excelimg/word/wdsjtb1-4.png"/>
						    	<img class="wdsjtb1-4" src="../../../static/workoff/excelimg/word/wdsjtb1-4-1.png" @mousemove="Loginwdsj1_4"/>
							</div>
							<div class="qnbox nr1_4" v-show="isShowwdsj1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdsj1-1.png"/>
								<img class="wdsjtb1-2" src="../../../static/workoff/excelimg/word/wdsjtb1-5.png"/>
						    	<img class="wdsjtb1-5" src="../../../static/workoff/excelimg/word/wdsjtb1-5-1.png" @click="Loginwdsj1_5"/>
							</div>
							<div class="qnbox nr1_4" v-show="isShowwdsj1_6">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdsj1-1.png"/>
								<img class="wdsjtb1-2" src="../../../static/workoff/excelimg/word/wdsjtb1-6.png"/>
						    	<img class="wdsjtb1-6" src="../../../static/workoff/excelimg/word/wdsjtb1-6-1.png" @click="Loginwdsj1_6"/>
							</div>
							<div class="qnbox nr1_4" v-show="isShowwdsj1_7">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdsj1-4.png"/>

							</div>
							<!-- 加粗居中 -->
							<div class="qnbox nr1_4" v-show="isShowwdjc1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdjc1-1.png"/>
								<img class="jchbtb1-4" src="../../../static/workoff/excelimg/layout/jchbtb1-2-1.png"  @mousemove="Loginwdjc1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdjc1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdjc1-2.png"/>
								<img class="jchbtb1-5" src="../../../static/workoff/excelimg/layout/jchbtb1-3.png"  @click="Loginwdjc1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdjc1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdjc1-3.png"/>
								<img class="jztb1-1" src="../../../static/workoff/excelimg/layout/jztb1-1.png"  @mousemove="Loginwdjc1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdjc1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdjc1-4.png"/>
								<img class="jztb1-2" src="../../../static/workoff/excelimg/layout/jztb1-2.png"  @click="Loginwdjc1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdjc1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdjc1-5.png"/>

						    </div>
							<!-- 设置为红色 -->
							<div class="qnbox nr1_4" v-show="isShowwdys1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdys1-1.png"/>
								<img class="wdystb1-1" src="../../../static/workoff/excelimg/word/wdystb1-1.png"  @mousemove="Loginwdys1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdys1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdys1-2.png"/>
								<img class="wdystb1-2" src="../../../static/workoff/excelimg/word/wdystb1-2.png"  @click="Loginwdys1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdys1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdys1-3.png"/>
								<img class="wdystb1-3" src="../../../static/workoff/excelimg/word/wdystb1-3.png"  @mousemove="Loginwdys1_3"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdys1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdys1-4.png"/>
								<img class="wdystb1-4" src="../../../static/workoff/excelimg/word/wdystb1-4.png"  @click="Loginwdys1_4"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdys1_5">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdys1-5.png"/>

						    </div>
							<!-- 自然段颜色页面(凸显)显示 -->
							<div class="qnbox nr1_4" v-show="isShowwdtx1_1">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdtx1-1.png"/>
								<img class="wdtxtb1-1" src="../../../static/workoff/excelimg/word/wdtxtb1-1.png"  @mousemove="Loginwdtx1_1"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdtx1_2">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdtx1-2.png"/>
								<img class="wdtxtb1-2" src="../../../static/workoff/excelimg/word/wdtxtb1-2.png"  @click="Loginwdtx1_2"/>
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdtx1_3">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdtx1-3.png"  @click="Loginwdtx1_3"/>
								<!-- <img class="wdtxtb1-2" src="../../../static/workoff/excelimg/word/wdtxtb1-2.png"  @click="Loginwdtx1_2"/> -->
						    </div>
							<div class="qnbox nr1_4" v-show="isShowwdtx1_4">
								<img class="qnbg" src="../../../static/workoff/excelimg/word/wdtx1-4.png"/>
								<!-- <img class="wdtxtb1-2" src="../../../static/workoff/excelimg/word/wdtxtb1-2.png"  @click="Loginwdtx1_2"/> -->
						    </div>

						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
							<p v-if="isShowwdzt1_1 || isShowwdzt1_2 || isShowwdzt1_3 || isShowwdzt1_4 || isShowwdzt1_5 || isShowwdzt1_6 || isShowwdzt1_7 || isShowwdzt1_8 || isShowwdzt1_9 || isShowwdzt1_10">先采用<span style="color: red;font-weight:bold;">快捷键</span>全选内容，再将<span style="color: red;font-weight:bold;">字体</span>设置为<span style="color: red;font-weight:bold;">楷体，字号</span>设置为<span style="color: red;font-weight:bold;">小四</span></p>
							<p v-if="isShowwdhj1_1 || isShowwdhj1_2 || isShowwdhj1_3 || isShowwdhj1_4 || isShowwdhj1_5">将<span style="color: red;font-weight:bold;">行距</span>设置为<span style="color: red;font-weight:bold;">1.5</span>倍</p>
							<p v-if="isShowwdsj1_1 || isShowwdsj1_2 || isShowwdsj1_3 || isShowwdsj1_4 || isShowwdsj1_5 || isShowwdsj1_6 || isShowwdsj1_7">将<span style="color: red;font-weight:bold;">首行缩进2字符</span></p>
							<p v-if="isShowwdjc1_1 || isShowwdjc1_2 || isShowwdjc1_3 || isShowwdjc1_4 || isShowwdjc1_5">将<span style="color: red;font-weight:bold;">标题加粗，并居中</span></p>
							<p v-if="isShowwdys1_1 || isShowwdys1_2 || isShowwdys1_3 || isShowwdys1_4 || isShowwdys1_5">将<span style="color: red;font-weight:bold;">2015</span>设置为<span style="color: red;font-weight:bold;">红色</span></p>
							<p v-if="isShowwdtx1_1 || isShowwdtx1_2 || isShowwdtx1_3 || isShowwdtx1_4">用<span style="color: red;font-weight:bold;">黄色突出显示</span>最后自然段</p>
						<!-- <div v-if="isShowKjdyTip02">
							<p>使用快捷短语操作练习：</p>
							<p>请采用/+快捷编码的方式（例如：<span style="color: red;font-weight:bold;">/结束</span>），给当前顾客发送一条结束语的快捷短语</p>
						</div>
						<div v-if="isShowKjdyTip03">
							<p>导入快捷短语操作练习：</p>
							<p>请先下载下方的快捷短语表格，并保存在桌面上</p>
							<p><a @click="downloadKjdyFile">点击下载“快捷短语.csv”</a></p>
						</div>
						<div v-if="isShowKjdyTip04">
							<p>导入快捷短语操作练习：</p>
							<p>请将下载好的快捷短语表格导入到千牛上</p>
						</div> -->
					</div>
				</div>
				<div id="studytip-six" class="stoptip" v-if="OnInline=='false'">
					<div class="tip">
						<span class="el-icon-success"></span>
						 <p>你已完成办公软件的功能学习，<br>接下来请完成《办公软件模拟实操》。</p>
	        <!-- <a class="restart" @click="restartVideoLast"><i class="el-icon-refresh-left"></i>重看视频</a> -->
	        <a class="startstudy" href="/excelstudy" style="width: 230px;border-radius: 5px;">去完成《办公软件模拟实操》</a>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" src="../../../static/newqianniu/ppt.png" />
							<div class="con-box">
								<p>办公软件的功能学习.ppt</p>
								<p>
									<a v-if="isOpenPpt6" class="btn-open" @click="viewPpt6(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt6">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer6"></div>
				</div>
	    </el-tab-pane>
		    	<!--第7步 下载安装WPS-->

	  </el-tabs>
	 </div>
</template>

<script>
import PDFObject from '../../assets/js/pdfobject.min'
export default {
  data() {
    return {
		data: {
            positionX: 0,
            positionY: 0,
        },
		OnInline:'false',//小助手跳转
    	tabIndex: 1, //序号
    	tabCurrent: 'zero', //当前标签页
    	isShowBtn: [], //是否显示开始练习按钮
    	isOpenPpt: false, //是否展开ppt
    	isOpenPpt2: false, //是否展开ppt
    	isOpenPpt3: false, //是否展开ppt
    	isOpenPpt4: false, //是否展开ppt
    	isOpenPpt5: false, //是否展开ppt
      isOpenPpt6: false, //是否展开ppt
      isOpenPpt7: false, //是否展开ppt
      isOpenPpt8: false, //是否展开ppt
      isOpenPpt9: false, //是否展开ppt
      isOpenPpt10: false, //是否展开ppt
      isOpenPpt11: false, //是否展开ppt
      isOpenPpt12: false, //是否展开ppt
    	//第1步
    	isShowQnIcon: true, //是否显示wps图标
    	isShowQnIcon2: false, //点击wps图标
    	isShowQnIcon3: false, //移入新建
    	isShowQnIcon4: false, //点击新建后
		isShowQnIcon5:false,//鼠标移入新建表格
		isShowQnIcon6:false,//点击新建表格
		isShowQnIcon7:false,//移入空白文档
		isShowQnIcon8:false,//点击空白文档
		isShowQnIcon9:false,//点击空白文档延时两秒
		isShowQnIcon10:false,//点击B列
		isShowQnIcon11:false,//点击B列延时两秒
		isShowQnIcon12:false,//点击第6行
		isShowQnIcon13:false,//点击第6行延时两秒
		isShowQnIcon14:false,//点击第6行第三个单元格



      isShowLoginImg: false, //是否显示电竞图片
      name: '', //登录账号
     	password: '', //密码
     	showPassword: false, //显示账号密码
     	isShowRnd: false, //显示获取随机码
     	rnd: '', //随机密码
     	showRnd: false, //显示随机码
     	isShowLoginIndex: false, //显示登录后图片
     	isShowLoginIndexTwo: false, //显示接待中心
     	//第2步
		isShownr1_1:true,//是否显示J第2步第一张图片
		isShownr1_2:false,//点击J2单元框
     	nr_input:'',//J2输入框
		isShownr1_3:false,//敲下回车键后
		isShownr1_3_1:false,//敲下回车键后延时两秒
		isShownr1_4:false,//点击A3
		nr_input2:'',//A3输入框
		isShownr1_5:false,//按下ctrl+；
		isShownr1_6:false,//按下enter
		isShownr1_6_1:false,//按下enter延时两秒
		isShownr1_7:false,//点击A（下托前）
		isShownr1_8:false,//按下ctrl+c
		isShownr1_9:false,//按下ctrl+c延时两秒
		isShownr1_10:false,//按下ctrl+V
		isShownr1_11:false,//按下ctrl+V延时两秒
		isShownr1_12:false,//点击c列
		isShownr1_13:false,//c列鼠标点击右键
		isShownr1_14:false,//键鼠标移入插入列
		isShownr1_15:false,//点击右键鼠标移入插入列
		isShownr1_16:false,//点击右键鼠标移入插入列延长两秒
		isShownr1_17:false,//点击第六6行
		isShownr1_17_1:false,//点击右键
		isShownr1_17_2:false,//点击右键移入
		isShownr1_17_3:false,//右键点击
		isShownr1_18:false,//右键点击以后的页面
		isShownr1_19:false,//过渡求和页面
		isShowqh1_1:false,//点击I3
		isShowqh1_2:false,//点击F3
		isShowqh1_3:false,//点击G3
		isShowqh1_4:false,//点击H3
		qh1_input:'',//求和输入框
		qh1_input1:'',//求和输入框
		isShowqh1_5:false,//按下enter
		// 平均
        isShowpj1_1:false,//延时两秒（显示求和页面）
        isShowpj1_2:false,//点击J3
		isShowpj1_3:false,//点击I3
		isShowpj1_4:false,//按下enter
		pj_input1:'293',//I3输入框
		pj1_input:'',//I3输入框
		// 总分
		isShowzf1_1:false,//k3平均页面显示
		isShowzf1_2:false,//点击K3单元格
		isShowzf1_3:false,//点击I3单元格
		isShowzf1_4:false,//点击I3单元格
		isShowzf1_5:false,//按下enter

		zf1_input:'',//E3输入框

		//修改第一张
		isShowxg1_1:false,//延时两秒（显示新建页面）
		isShowxg1_2:false,//点击下方的Sheet1
		xg_input1:'Sheet1',//Sheet1修改输入框
		isShowxg1_3:false,//按下enter
        //新建
		isShowxj1_1:false,//按下enter延时两秒显示新建页面
		isShowxj1_2:false,//移入+号
		isShowxj1_3:false,//点击+号
		//占比
		isShowzb1_1:false,//占比页面显示
		isShowzb1_2:false,//点击C3
		isShowzb1_3:false,//点击B3
		isShowzb1_4:false,//点击A3
		zb_input1:'',//A3输入框
		isShowzb1_5:false,//按下enter
		//修改第二张
		isShowxg2_1:false,//延时两秒显示第二张修改页面
		isShowxg2_2:false,//点击下面的Sheet2
		xg_input2:'Sheet2',//下面Sheet2输入框
		isShowxg2_3:false,//按下enter


        // 第三步
        isShowzt1_1:true,//是否显示第三步第一张图片
		isShowzt1_2:false,//鼠标移入字体样式
		isShowzt1_3:false,//鼠标点击字体样式
		isShowzt1_4:false,//鼠标移入微软雅黑
		isShowzt1_5:false,//鼠标点击微软雅黑
		// 居中
		isShowjz1_1:false,//延时两秒显示居中页面
		isShowjz1_2:false,//鼠标移入居中
		isShowjz1_3:false,//鼠标点击居中
		// 框线
		isShowkx1_1:false,//延迟两秒显示框线页面
		isShowkx1_2:false,//鼠标移入框线
		isShowkx1_3:false,//鼠标点击框线
		isShowkx1_4:false,//鼠标移入所有框线
		isShowkx1_5:false,//鼠标点击所有框线
		// 调A列
		// isShowta1_1:false,//延迟两秒调整A页面显示
		isShowta1_2:false,//移到A列
		isShowta1_3:false,//点击A列
		// 加粗合并第一行
		isShowjchb1_1:false,//延迟两秒显示加粗合并第一行页面
		isShowjchb1_2:false,//鼠标移入大号字体
		isShowjchb1_3:false,//鼠标点击大号字体（第一次）
		isShowjchb1_4:false,//鼠标点击大号字体（第二次）
		isShowjchb1_5:false,//鼠标移入字体加粗
		isShowjchb1_6:false,//鼠标点击字体加粗
		isShowjchb1_7:false,//鼠标移入居中合并
		isShowjchb1_8:false,//鼠标点击居中合并
		isShowjchb1_9:false,//鼠标移入设置颜色
		isShowjchb1_10:false,//鼠标移入颜色
		isShowjchb1_11:false,//鼠标点击颜色
		isShowjchb1_12:false,//
		//颜色换行第二行
		isShowyshh1_1:false,//延时两秒第二行颜色换行页面显示
        isShowyshh1_2:false,//鼠标移入更换字体颜色
        isShowyshh1_3:false,//鼠标点击更换字体颜色
        isShowyshh1_4:false,//鼠标移入自动换行
        isShowyshh1_5:false,//鼠标点击自动换行
		// 冻结
		isShowdj1_1:false,//延时两秒冻结页面显示
		isShowdj1_2:false,//鼠标移入冻结窗格
		isShowdj1_3:false,//鼠标点击冻结窗格
		isShowdj1_4:false,//鼠标移入冻结第二行
		isShowdj1_5:false,//鼠标点击冻结第二行
		// isShownr1_16:false,//插入列后延迟两秒
		// 保留小数
		isShowxs1_1:false,//延迟两秒保留小数页面显示
		isShowxs1_2:false,//鼠标移入常规
		isShowxs1_3:false,//点击常规下标
		isShowxs1_4:false,//鼠标移入其他数字格式
		isShowxs1_5:false,//鼠标点击其他数字格式
		isShowxs1_6:false,//鼠标点击数值
		isShowxs1_7:false,//鼠标移入输入框
		isShowxs1_8:false,//鼠标点击减号输入框
		isShowxs1_9:false,//鼠标移动到确定
		isShowxs1_10:false,//鼠标点击确定
		//占比保留两位小数
		isShowzbbl1_1:false,//延时两秒显示占比保留两位小数页面
		isShowzbbl1_2:false,//鼠标移入常规
		isShowzbbl1_3:false,//点击常规下标
		isShowzbbl1_4:false,//鼠标移动到%
		isShowzbbl1_5:false,//鼠标点击%
		// 第四步
		// 保存文件
        isShowbc1_1:true,//是否显示第四步第一张图片
		bc_input1:'66.67%',//保存第一张图的输入框（用于监听ctrl+s）
		isShowbc1_2:false,//监听ctrl+s
		isShowbc1_3:false,//鼠标移入我的桌面
		isShowbc1_4:false,//鼠标点击我的桌面
		isShowbc1_5:false,//鼠标点击办公软件培训
		isShowbc1_6:false,//鼠标点击文件名
		isShowbc1_7:false,//再点击一次
		isShowbc1_8:false,//显示输入框
		bc_input2:'',
		isShowbc1_9:false,//点击确定
		//另存为
		isShowlc1_1:false,//延时两秒显示另存页面
		isShowlc1_2:false,//点击右键
		isShowlc1_3:false,//鼠标移入另存为
		isShowlc1_4:false,//鼠标点击另存为
		isShowlc1_5:false,//鼠标移入我的桌面
		isShowlc1_6:false,//鼠标点击我的桌面
		isShowlc1_7:false,//鼠标点击保存
		// 第五步
		// 发送文件
		isShowfs1_1:true,//是否显示第五步第一张图片
		isShowfs1_2:false,//鼠标移入关闭
		isShowfs1_3:false,//鼠标点击关闭
		isShowfs1_4:false,//键盘点击表格
		isShowfs1_5:false,//键盘按下ctrl+c
		isShowfs1_6:false,//键盘按下ctrl+v
		isShowfs1_7:false,//点击发送
		// 第六步
		// Word基础功能
		isShowwdzt1_1:true,//是否显示第六步第一张图片
		isShowwdzt1_2:false,//ctrl+A
		isShowwdzt1_3:false,//鼠标移入字体下拉
		isShowwdzt1_4:false,//鼠标点击字体下拉
		isShowwdzt1_5:false,//鼠标移入楷体
		isShowwdzt1_6:false,//鼠标点击楷体
		isShowwdzt1_7:false,//鼠标移入字体大小
		isShowwdzt1_8:false,//鼠标点击字体大小
		isShowwdzt1_9:false,//鼠标移入小四
		isShowwdzt1_10:false,//鼠标点击小四
		// 行距
		isShowwdhj1_1:false,//延迟两秒显示行距页面
		isShowwdhj1_2:false,//鼠标移入行距
		isShowwdhj1_3:false,//鼠标点击行距
		isShowwdhj1_4:false,//鼠标移入1.5
		isShowwdhj1_5:false,//鼠标点击1.5
		// 首行缩进
		isShowwdsj1_1:false,//延时两秒显示首行缩进页面
		isShowwdsj1_1_1:false,//点击鼠标右键
		isShowwdsj1_2:false,//鼠标移入段落
		isShowwdsj1_3:false,//鼠标点击段落
		isShowwdsj1_4:false,//鼠标点击特殊格式
		isShowwdsj1_5:false,//鼠标移动到首行缩进
		isShowwdsj1_6:false,//鼠标点击首行缩进
		isShowwdsj1_7:false,//鼠标点击确定
		//加粗居中
		isShowwdjc1_1:false,//延时两秒显示加粗居中页面
		isShowwdjc1_2:false,//鼠标移到加粗
		isShowwdjc1_3:false,//鼠标点击加粗
		isShowwdjc1_4:false,//鼠标移到居中
		isShowwdjc1_5:false,//鼠标点击居中
		//颜色设置为红色
		isShowwdys1_1:false,//延时两秒显示设置颜色页面
		isShowwdys1_2:false,//鼠标移到颜色
		isShowwdys1_3:false,//鼠标点击颜色
		isShowwdys1_4:false,//鼠标移到红色
		isShowwdys1_5:false,//鼠标点击红色
		// 自然段颜色页面显示(凸显页面)
		isShowwdtx1_1:false,//延迟两秒自然段颜色页面显示(凸显页面)显示
		isShowwdtx1_2:false,//鼠标移到段落颜色
		isShowwdtx1_3:false,//鼠标点击段落颜色
		isShowwdtx1_4:false,//鼠标点击空白











	}
  },
  mounted() {
		document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-'+this.tabCurrent).show();
      this.$set(this.isShowBtn, this.tabCurrent, true)
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', () => { //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);

  var _this=this
  document.onkeydown = function (event) {
    let key = window.event.keyCode;
	console.log(key,88877)
    if (key === 83 && event.ctrlKey) {
	    event.returnValue = false // 阻止直接保存网页
		if(_this.isShowbc1_1==true){
			_this.showLoginbc1_1()
		}

      // 监听ctrl+S组合键

    }
    if (key === 67 && event.ctrlKey) {

		if(_this.isShowfs1_4==true){
			_this.Loginfs1_4()
		}
		if(_this.isShownr1_7==true){
			_this.showLoginnr1_7()
		}


      // 监听ctrl+C组合键

    }
    if (key === 86 && event.ctrlKey) {
		if(_this.isShowfs1_5==true){
			_this.Loginfs1_5()
		}
		if(_this.isShownr1_9==true){
			_this.listenTwo_3()
		}


      // 监听ctrl+V组合键

    }
    if (key === 13) {
		if(_this.isShowqh1_1==true){
			_this.showLoginnr1_20_1()
		}
		if(_this.isShowpj1_2==true){
			_this.Loginpj1_2_1()
		}if(_this.isShowzb1_2==true){
			_this.Loginzb1_2_1()
		}
		if(_this.isShowqh1_4==true){
			_this.showLoginqh1_4()
		}
		if(_this.isShowpj1_3==true){
			_this.showLoginpj1_1()
		}
		if(_this.isShowzf1_2==true){
			_this.Loginzf1_2_1()
		}
		if(_this.isShowzf1_4==true){
			_this.showLoginzf1_1()
		}
		if(_this.isShowzb1_4==true){
			_this.showLoginzb1_1()
		}
		if(_this.isShowfs1_6==true){
			_this.Loginfs1_6()
		}



      // 监听回车

    }
    if (key === 65 && event.ctrlKey) {
		if(_this.isShowwdzt1_1==true){
			event.returnValue = false // 阻止
			_this.Loginwdzt1_1()
		}




      // 监听ctrl+A

    }

  }

      // var step = this.$route.query.step;
      // if(step == 12){
      //     this.studyNext('#tab-twelve')
      // }
  },
  watch: {
  	kjdy: function() {
  		if(this.kjdy == '/结束') {
  			this.isShowKjdy06 = true
  		}
  	}
  },
  directives: {
    focus: {
      inserted: function(el, {value}) {
        if(value){
          el.focus();
        }
      }
    }
  },
  created(){
	  if(this.$route.query.OnInline){
		 this.OnInline=this.$route.query.OnInline
	  }
  },
  methods: {
  	formatDate: function (value) {
	    let date = new Date(value);
	    let y = date.getFullYear();
	    let MM = date.getMonth() + 1;
	    MM = MM < 10 ? ('0' + MM) : MM;
	    let d = date.getDate();
	    d = d < 10 ? ('0' + d) : d;
	    let h = date.getHours();
	    h = h < 10 ? ('0' + h) : h;
	    let m = date.getMinutes();
	    m = m < 10 ? ('0' + m) : m;
	    let s = date.getSeconds();
	    s = s < 10 ? ('0' + s) : s;
	    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	  },
	  //第1步-开始播放视频
	  startVideo() {
	  	document.getElementById('zero').play();
	  	$('#startvideo').hide();
	  },
	  //初始化第1步状态值
    initFirst() {
    	this.isShowQnIcon= true,
    	this.isShowQnIcon2= false,
    	this.isShowQnIcon3= false,
    	this.isShowQnIcon4= false,
		this.isShowQnIcon5=false,
		this.isShowQnIcon6=false,
		this.isShowQnIcon7=false,
		this.isShowQnIcon8=false,
		this.isShowQnIcon9=false,
		this.isShowQnIcon10=false,
		this.isShowQnIcon11=false,
		this.isShowQnIcon12=false,
		this.isShowQnIcon13=false,
		this.isShowQnIcon14=false

    },
    //初始化第2步状态值
    initSecond() {
    	this.isShownr1_1=true,//是否显示J第2步第一张图片
		this.isShownr1_2=false,//点击J2单元框
     	this.nr_input='',//J2输入框
		this.isShownr1_3=false,//敲下回车键后
		this.isShownr1_3_1=false,//敲下回车键后延时两秒
		this.isShownr1_4=false,//点击A3
		this.nr_input2='',//A3输入框
		this.isShownr1_5=false,//按下ctrl+；
		this.isShownr1_6=false,//按下enter
		this.isShownr1_6_1=false,//按下enter延时两秒
		this.isShownr1_7=false,//点击A（下托前）
		this.isShownr1_8=false,//按下ctrl+c
		this.isShownr1_9=false,//按下ctrl+c延时两秒
		this.isShownr1_10=false,//按下ctrl+V
		this.isShownr1_11=false,//按下ctrl+V延时两秒
		this.isShownr1_12=false,//点击c列
		this.isShownr1_13=false,//c列鼠标点击右键
		this.isShownr1_14=false,//键鼠标移入插入列
		this.isShownr1_15=false,//点击右键鼠标移入插入列
		this.isShownr1_16=false,//点击右键鼠标移入插入列延长两秒
		this.isShownr1_17=false,//点击第六6行
		this.isShownr1_17_1=false,//点击右键
		this.isShownr1_17_2=false,//点击右键移入
		this.isShownr1_17_3=false,//右键点击
		this.isShownr1_18=false,//右键点击以后的页面
		this.isShownr1_19=false,//过渡求和页面
		this.qh1_input='',//求和输入框
		this.qh1_input1='',//求和输入框
		this.isShowqh1_1=false,//点击I3
		this.isShowqh1_2=false,//点击F3
		this.isShowqh1_3=false,//点击G3
		this.isShowqh1_4=false,//点击H3
		// this.qh_input1='',
		this.isShowqh1_5=false,//按下enter
		// 平均
        this.isShowpj1_1=false,//延时两秒（显示求和页面）
        this.isShowpj1_2=false,//点击J3
		this.isShowpj1_3=false,//点击I3
		this.isShowpj1_4=false,//按下enter
		this.pj1_input='',//I3输入框
		// 总分
		this.isShowzf1_1=false,//k3平均页面显示
		this.isShowzf1_2=false,//点击K3单元格
		this.isShowzf1_3=false,//点击I3单元格
		this.isShowzf1_4=false,//点击I3单元格
		this.isShowzf1_5=false,//按下enter
		this.zf1_input='',//E3输入框
		//修改第一张
		this.isShowxg1_1=false,//延时两秒（显示新建页面）
		this.isShowxg1_2=false,//点击下方的Sheet1
		this.xg_input1='Sheet1',//Sheet1修改输入框
		this.isShowxg1_3=false,//按下enter
        //新建
		this.isShowxj1_1=false,//按下enter延时两秒显示新建页面
		this.isShowxj1_2=false,//移入+号
		this.isShowxj1_3=false,//点击+号
		//占比
		this.isShowzb1_1=false,//占比页面显示
		this.isShowzb1_2=false,//点击C3
		this.isShowzb1_3=false,//点击B3
		this.isShowzb1_4=false,//点击A3
		this.zb_input1='',//A3输入框
		this.isShowzb1_5=false,//按下enter
		//修改第二张
		this.isShowxg2_1=false,//延时两秒显示第二张修改页面
		this.isShowxg2_2=false,//点击下面的Sheet2
		this.xg_input2='Sheet2',//下面Sheet2输入框
		this.isShowxg2_3=false//按下enter
    },
    //初始化第3步状态值
    initThird() {
    	this.isShowzt1_1=true,//是否显示第三步第一张图片
		this.isShowzt1_2=false,//鼠标移入字体样式
		this.isShowzt1_3=false,//鼠标点击字体样式
		this.isShowzt1_4=false,//鼠标移入微软雅黑
		this.isShowzt1_5=false,//鼠标点击微软雅黑
		// 居中
		this.isShowjz1_1=false,//延时两秒显示居中页面
		this.isShowjz1_2=false,//鼠标移入居中
		this.isShowjz1_3=false,//鼠标点击居中
		// 框线
		this.isShowkx1_1=false,//延迟两秒显示框线页面
		this.isShowkx1_2=false,//鼠标移入框线
		this.isShowkx1_3=false,//鼠标点击框线
		this.isShowkx1_4=false,//鼠标移入所有框线
		this.isShowkx1_5=false,//鼠标点击所有框线
		// 调A列
		// this.isShowta1_1=false,//延迟两秒调整A页面显示
		this.isShowta1_2=false,//移到A列
		this.isShowta1_3=false,//点击A列
		// 加粗合并第一行
		this.isShowjchb1_1=false,//延迟两秒显示加粗合并第一行页面
		this.isShowjchb1_2=false,//鼠标移入大号字体
		this.isShowjchb1_3=false,//鼠标点击大号字体（第一次）
		this.isShowjchb1_4=false,//鼠标点击大号字体（第二次）
		this.isShowjchb1_5=false,//鼠标移入字体加粗
		this.isShowjchb1_6=false,//鼠标点击字体加粗
		this.isShowjchb1_7=false,//鼠标移入居中合并
		this.isShowjchb1_8=false,//鼠标点击居中合并
		this.isShowjchb1_9=false,//鼠标移入设置颜色
		this.isShowjchb1_10=false,//鼠标移入颜色
		this.isShowjchb1_11=false,//鼠标点击颜色
		this.isShowjchb1_12=false,//
		//颜色换行第二行
		this.isShowyshh1_1=false,//延时两秒第二行颜色换行页面显示
        this.isShowyshh1_2=false,//鼠标移入更换字体颜色
        this.isShowyshh1_3=false,//鼠标点击更换字体颜色
        this.isShowyshh1_4=false,//鼠标移入自动换行
        this.isShowyshh1_5=false,//鼠标点击自动换行
		// 冻结
		this.isShowdj1_1=false,//延时两秒冻结页面显示
		this.isShowdj1_2=false,//鼠标移入冻结窗格
		this.isShowdj1_3=false,//鼠标点击冻结窗格
		this.isShowdj1_4=false,//鼠标移入冻结第二行
		this.isShowdj1_5=false,//鼠标点击冻结第二行
		// isShownr1_16:false,//插入列后延迟两秒
		// 保留小数
		this.isShowxs1_1=false,//延迟两秒保留小数页面显示
		this.isShowxs1_2=false,//鼠标移入常规
		this.isShowxs1_3=false,//点击常规下标
		this.isShowxs1_4=false,//鼠标移入其他数字格式
		this.isShowxs1_5=false,//鼠标点击其他数字格式
		this.isShowxs1_6=false,//鼠标点击数值
		this.isShowxs1_7=false,//鼠标移入输入框
		this.isShowxs1_8=false,//鼠标点击减号输入框
		this.isShowxs1_9=false,//鼠标移动到确定
		this.isShowxs1_10=false,//鼠标点击确定
		//占比保留两位小数
		this.isShowzbbl1_1=false,//延时两秒显示占比保留两位小数页面
		this.isShowzbbl1_2=false,//鼠标移入常规
		this.isShowzbbl1_3=false,//点击常规下标
		this.isShowzbbl1_4=false,//鼠标移动到%
		this.isShowzbbl1_5=false//鼠标点击%
    },
    //初始化第4步状态值
    initFour() {
     	this.isShowbc1_1=true,//是否显示第四步第一张图片
		this.bc_input1='66.67%',//保存第一张图的输入框（用于监听ctrl+s）
		this.isShowbc1_2=false,//监听ctrl+s
		this.isShowbc1_3=false,//鼠标移入我的桌面
		this.isShowbc1_4=false,//鼠标点击我的桌面
		this.isShowbc1_5=false,//鼠标点击办公软件培训
		this.isShowbc1_6=false,//鼠标点击文件名
		this.isShowbc1_7=false,//再点击一次
		this.isShowbc1_8=false,//显示输入框
		this.bc_input2='',
		this.isShowbc1_9=false,//点击确定
		//另存为
		this.isShowlc1_1=false,//延时两秒显示另存页面
		this.isShowlc1_2=false,//点击右键
		this.isShowlc1_3=false,//鼠标移入另存为
		this.isShowlc1_4=false,//鼠标点击另存为
		this.isShowlc1_5=false,//鼠标移入我的桌面
		this.isShowlc1_6=false,//鼠标点击我的桌面
		this.isShowlc1_7=false//鼠标点击保存
    },
    //初始化第5步状态值
    initFive() {
    	this.isShowfs1_1=true,//是否显示第五步第一张图片
		this.isShowfs1_2=false,//鼠标移入关闭
		this.isShowfs1_3=false,//鼠标点击关闭
		this.isShowfs1_4=false,//鼠标点击表格
		this.isShowfs1_5=false,//键盘按下ctrl+c
		this.isShowfs1_6=false//键盘按下ctrl+v

    },
    //初始化第6步状态值
    initSix() {
    // Word基础功能
		this.isShowwdzt1_1=true,//是否显示第六步第一张图片
		this.isShowwdzt1_2=false,//ctrl+A
		this.isShowwdzt1_3=false,//鼠标移入字体下拉
		this.isShowwdzt1_4=false,//鼠标点击字体下拉
		this.isShowwdzt1_5=false,//鼠标移入楷体
		this.isShowwdzt1_6=false,//鼠标点击楷体
		this.isShowwdzt1_7=false,//鼠标移入字体大小
		this.isShowwdzt1_8=false,//鼠标点击字体大小
		this.isShowwdzt1_9=false,//鼠标移入小四
		this.isShowwdzt1_10=false,//鼠标点击小四
		// 行距
		this.isShowwdhj1_1=false,//延迟两秒显示行距页面
		this.isShowwdhj1_2=false,//鼠标移入行距
		this.isShowwdhj1_3=false,//鼠标点击行距
		this.isShowwdhj1_4=false,//鼠标移入1.5
		this.isShowwdhj1_5=false,//鼠标点击1.5
		// 首行缩进
		this.isShowwdsj1_1=false,//延时两秒显示首行缩进页面
		this.isShowwdsj1_1_1=false,//点击鼠标右键
		this.isShowwdsj1_2==false,//鼠标移入段落
		this.isShowwdsj1_3=false,//鼠标点击段落
		this.isShowwdsj1_4=false,//鼠标点击特殊格式
		this.isShowwdsj1_5=false,//鼠标移动到首行缩进
		this.isShowwdsj1_6=false,//鼠标点击首行缩进
		this.isShowwdsj1_7=false,//鼠标点击确定
		//加粗居中
		this.isShowwdjc1_1=false,//延时两秒显示加粗居中页面
		this.isShowwdjc1_2=false,//鼠标移到加粗
		this.isShowwdjc1_3=false,//鼠标点击加粗
		this.isShowwdjc1_4=false,//鼠标移到居中
		this.isShowwdjc1_5=false,//鼠标点击居中
		//颜色设置为红色
		this.isShowwdys1_1=false,//延时两秒显示设置颜色页面
		this.isShowwdys1_2=false,//鼠标移到颜色
		this.isShowwdys1_3=false,//鼠标点击颜色
		this.isShowwdys1_4=false,//鼠标移到红色
		this.isShowwdys1_5=false,//鼠标点击红色
		// 自然段颜色页面显示(凸显页面)
		this.isShowwdtx1_1=false,//延迟两秒自然段颜色页面显示(凸显页面)显示
		this.isShowwdtx1_2=false,//鼠标移到段落颜色
		this.isShowwdtx1_3=false,//鼠标点击段落颜色
		this.isShowwdtx1_4=false//鼠标点击空白
    },
    //初始化第7步状态值
    initSeven() {
     	this.isShowZtsbicon = true
     	this.isShowZtsb01 = false
     	this.isShowZtsb02 = false
     	this.isShowZtsb03 = false
     	this.isShowZtsb04 = false
     	this.isShowZtsb05 = false
      this.isShowZtsb06 = false
      this.isShowZtsbTip01 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = false;
    },
    //初始化第8步状态值
    initEight() {
     	this.isShowZjgnicon = true
     	this.isShowZjgn01 = false
     	this.isShowZjgn02 = false
     	this.isShowZjgn03 = false
     	this.isShowZjgn04 = false
     	this.isShowZjgn05 = false
    },
    //初始化第9步状态值
    initNine() {
     	this.isShowTjgnicon = true
     	this.isShowTjgn01 = false
     	this.isShowTjgn02 = false
     	this.isShowTjgn03 = false
     	this.isShowTjgn04 = false
     	this.isShowTjgn05 = false
     	this.isShowTjgn06 = false
    },
    //初始化第10步状态值
    initTen() {
     	this.isShowDdcjicon = false
     	this.isShowDdcj01 = false
     	this.isShowDdcj02 = false
     	this.isShowDdcj03 = false
     	this.isShowDdcj04 = false
     	this.isShowDdcj05 = false
     	this.isShowDdcj06 = false
     	this.isShowDdcj07 = true
     	this.isShowDdcj08 = false
     	this.isShowDdcj09 = false
     	this.isShowDdcj10 = false
      this.isShowDdcjTip01 = true
      this.isShowDdcjTip02 = false
      this.isShowDdcjTip03 = false
      this.ddcjbz = ''
      this.ddcjdz = ''
      this.ddcjyf = ''
    },
    //初始化第11步状态值
    initEleven() {
     	this.isShowXjrwicon = true
     	this.isShowXjrw01 = false
     	this.isShowXjrw02 = false
     	this.isShowXjrw03 = false
     	this.isShowXjrw04 = false
     	this.isShowXjrw05 = false
     	this.isShowXjrw06 = false
      this.xjrwmt = this.getLastDaysFromToday(-1) + ' 09:00'
      this.xjrwsj = ''
      this.xjrwtxt = ''
    },
    //初始化第12步状态值
    initTwelve() {
     	this.isShowTcqnicon = true
     	this.isShowTcqn01 = false
     	this.isShowTcqn02 = false
     	this.isShowTcqn03 = false
     	this.isShowTcqn04 = false
     	this.isShowTcqn05 = false
     	this.isShowTcqn06 = false
     	this.isShowTcqn07 = false
     	this.isShowTcqn08 = false
     	this.isShowTcqn09 = false
     	this.isShowTcqn10 = false
     	this.isShowTcqnTip01 = true
     	this.isShowTcqnTip02 = false
    },
  	//初始化所有tab内容
  	initAll() {
  		$('#startvideo').hide();
  		this.isShowBtn = []
    	this.isOpenPpt = false
    	this.isOpenPpt2 = false
    	this.isOpenPpt3 = false
    	this.isOpenPpt4 = false
    	this.isOpenPpt5 = false
      this.isOpenPpt6 = false
      this.isOpenPpt7 = false
      this.isOpenPpt8 = false
      this.isOpenPpt9 = false
      this.isOpenPpt10 = false
      this.isOpenPpt11 = false
      this.isOpenPpt12 = false
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer7').height('0');
      $('#pdf_viewer8').height('0');
      $('#pdf_viewer9').height('0');
      $('#pdf_viewer10').height('0');
      $('#pdf_viewer11').height('0');
      $('#pdf_viewer12').height('0');
    	//第1步
    	this.initFirst()
     	//第2步
     	this.initSecond()
     	//第3步
     	this.initThird()
     	//第4步
     	this.initFour()
     	//第5步
     	this.initFive()
     	//第6步
      this.initSix()
      //第7步
      this.initSeven()
      //第8步
      this.initEight()
      //第9步
      this.initNine()
      //第10步
      this.initTen()
      //第11步
      this.initEleven()
      //第12步
      this.initTwelve()
     	$('.content').each(function(i) {
  			$(this).hide();
  		});
  		$('.stoptip').each(function(i) {
  			$(this).hide();
  		});
  		$('.video-box').not('#video-'+this.tabCurrent).each(function(i) {
  			$(this).hide();
  		});
  		$('#video-'+this.tabCurrent).show();
  	},
  	//tab切换
  	handleClick(tab, event) {
		  console.log(tab,111111)
  		this.tabIndex = parseInt(tab.index)+1
  		//内容初始化
  		this.initAll();
  		document.getElementById(this.tabCurrent).play();
  		$('video').not('#'+this.tabCurrent).each(function(i) {
  			var tabId = $(this).attr('id');
  			document.getElementById(tabId).pause();
  			document.getElementById(tabId).currentTime = 0;
  		});
      document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
	      $('#stoptip-'+this.tabCurrent).show();
        this.$set(this.isShowBtn, this.tabCurrent, true);
      }, false);
    },
  	//展开/收起ppt
    viewPpt(bol) {
    	if(this.isOpenPpt == true || !bol) {
    		this.isOpenPpt = false
    		$('#pdf_viewer').height('0');
    	}else {
    		this.isOpenPpt = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/30186a3c66eb47d2baff3a4a20b898c6.pdf', "#pdf_viewer", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt2(bol) {
    	if(this.isOpenPpt2 == true || !bol) {
    		this.isOpenPpt2 = false
    		$('#pdf_viewer2').height('0');
    	}else {
    		this.isOpenPpt2 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer2').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/1ec7bb26500c4642915ce394e0868ef2.pdf', "#pdf_viewer2", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt3(bol) {
    	if(this.isOpenPpt3 == true || !bol) {
    		this.isOpenPpt3 = false
    		$('#pdf_viewer3').height('0');
    	}else {
    		this.isOpenPpt3 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer3').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/f7ebc1dcca274d7988724f21a45dd216.pdf', "#pdf_viewer3", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt4(bol) {
    	if(this.isOpenPpt4 == true || !bol) {
    		this.isOpenPpt4 = false
    		$('#pdf_viewer4').height('0');
    	}else {
    		this.isOpenPpt4 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer4').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/8fb3a6ee5a50492daf527cf4af5df717.pdf', "#pdf_viewer4", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt5(bol) {
    	if(this.isOpenPpt5 == true || !bol) {
    		this.isOpenPpt5 = false
    		$('#pdf_viewer5').height('0');
    	}else {
    		this.isOpenPpt5 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer5').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/30df4c094d9a4aba83db818ef47d208f.pdf', "#pdf_viewer5", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt6(bol) {
    	if(this.isOpenPpt6 == true || !bol) {
    		this.isOpenPpt6 = false
    		$('#pdf_viewer6').height('0');
    	}else {
    		this.isOpenPpt6 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer6').height('700px');
          PDFObject.embed('http://res.study.itaojin.cn/2023-02/74edd4969b8e47c1920cf97981e227b0.pdf', "#pdf_viewer6", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt7(bol) {
    	if(this.isOpenPpt7 == true || !bol) {
    		this.isOpenPpt7 = false
    		$('#pdf_viewer7').height('0');
    	}else {
    		this.isOpenPpt7 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
        	$('#pdf_viewer7').height('700px');
          PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step7.pdf?version=1221', "#pdf_viewer7", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt8(bol) {
    	if(this.isOpenPpt8 == true || !bol) {
    		this.isOpenPpt8 = false
    		$('#pdf_viewer8').height('0');
    	}else {
    		this.isOpenPpt8 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer8').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step8.pdf?version=1221', "#pdf_viewer8", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt9(bol) {
    	if(this.isOpenPpt9 == true || !bol) {
    		this.isOpenPpt9 = false
    		$('#pdf_viewer9').height('0');
    	}else {
    		this.isOpenPpt9 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer9').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step9.pdf?version=1221', "#pdf_viewer9", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt10(bol) {
    	if(this.isOpenPpt10 == true || !bol) {
    		this.isOpenPpt10 = false
    		$('#pdf_viewer10').height('0');
    	}else {
    		this.isOpenPpt10 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer10').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step10.pdf?version=1221', "#pdf_viewer10", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt11(bol) {
    	if(this.isOpenPpt11 == true || !bol) {
    		this.isOpenPpt11 = false
    		$('#pdf_viewer11').height('0');
    	}else {
    		this.isOpenPpt11 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer11').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step11.pdf?version=1221', "#pdf_viewer11", options )
        }
    	}
    },
    //展开/收起ppt
    viewPpt12(bol) {
    	if(this.isOpenPpt12 == true || !bol) {
    		this.isOpenPpt12 = false
    		$('#pdf_viewer12').height('0');
    	}else {
    		this.isOpenPpt12 = true
    		var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if(PDFObject.supportsPDFs) {
          $('#pdf_viewer12').height('700px');
        	PDFObject.embed('//taojinyun.file.itaojin.cn/qianniusource/step12.pdf?version=1221', "#pdf_viewer12", options )
        }
    	}
    },
    //重播
    restartVideo() {
    	document.getElementById(this.tabCurrent).play();
    	$('#stoptip-'+this.tabCurrent).hide();
    },
    //最后一节-重看视频
    restartVideoLast() {
      this.initTwelve()
    	document.getElementById(this.tabCurrent).play();
    	$('#studytip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).hide();
    	$('#video-'+this.tabCurrent).show();
    	document.getElementById(this.tabCurrent).currentTime = 0
    },
    //开始实操练习
    startStudy() {
    	document.getElementById(this.tabCurrent).pause();
    	$('#stoptip-'+this.tabCurrent).hide();
			$('#video-'+this.tabCurrent).hide();
    	this.isShowBtn[this.tabCurrent] = false
    	$('#content-'+this.tabCurrent).show();
    	this.addRecord('START')
        // this.getFocusbc_1()
    },
    //下一关
    studyNext(next) {
    	this.initFirst()
    	this.initSecond()
    	this.initThird()
    	this.initFour()
    	this.initFive()
    	this.initSix()
    	this.initSeven()
    	this.initEight()
    	this.initNine()
    	this.initTen()
    	this.initEleven()
    	this.initTwelve()
    	$('#studytip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).hide();
    	$('#video-'+this.tabCurrent).show();
    	document.getElementById(this.tabCurrent).currentTime = 0
    	$(next).click();
    },
    //第1步-单击wps图标
    showLoginImg() {
    	this.isShowQnIcon = false
    	this.isShowQnIcon2 = true
    },
    //点击wps新建
    showLoginImg2() {
    	this.isShowQnIcon2 = false
    	this.isShowQnIcon3 = true
    	// this.isShowLoginImg = true
    },
	//点击新建
	showLoginImg3(){
		this.isShowQnIcon3 = false
		this.isShowQnIcon4 = true

	},
	//移动到新建表格
	showLoginImg4(){
		this.isShowQnIcon4 = false
		this.isShowQnIcon5 = true

	},
	//点击新建表格
	showLoginImg5(){
		this.isShowQnIcon5 = false,
		this.isShowQnIcon6 = true

	},
	//移到空白文档
	showLoginImg6(){
		this.isShowQnIcon6 = false,
		this.isShowQnIcon7 = true

	},
	//点击空白文档
	showLoginImg7(){
		this.isShowQnIcon7 = false,
		this.isShowQnIcon8 = true
		setTimeout(()=>{
			this.isShowQnIcon8 = false,
			this.isShowQnIcon9 = true
		},2000)

	},
	//点击b列
	showLoginImg8(){
		this.isShowQnIcon9 = false,
		this.isShowQnIcon10 = true
		setTimeout(()=>{
			this.isShowQnIcon10 = false,
			this.isShowQnIcon11 = true
		},2000)

	},
	// 点击第六行
	showLoginImg9(){
		let self = this
		this.isShowQnIcon11 = false,
		this.isShowQnIcon12 = true

    	setTimeout(()=>{
			this.isShowQnIcon12 = false,
			this.isShowQnIcon13 = true
		},2000)
	},
	// 点击第六行第三个
	showLoginImg10(){
		var self = this
		this.isShowQnIcon13 = false
		this.isShowQnIcon14 = true
		this.addRecord('END')


    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	//重练第1步-Excel界面介绍
	restartStudyFirst() {
    	this.initFirst()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    // //登录
    // loginIn() {
    //   if(this.name == '') {
    //     this.notify('<p>请输入账号</p>')
    //     return
    //   }else if(this.name != '淘金客服:001') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   if(this.password == '') {
    //     this.notify('<p>请输入密码</p>')
    //     return
    //   }else if(this.password != 'TJ2019') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   this.isShowLoginImg = false
    //   this.isShowRnd = true
    // },
    // //验证码登录
    // loginInRnd() {
    // 	if(this.rnd == '') {
    //     this.notify('<p>请输入短信验证码</p>')
    //     return
    //   }else if(this.rnd != '660220') {
    //     this.notify('<p>短信验证码错误</p>')
    //     return
    //   }
    //   this.isShowRnd = false
    //   this.isShowLoginIndex = true
    // },
    // //进入接待中心
    // enterJd() {
    // 	var self = this
    // 	this.isShowLoginIndex = false
    // 	this.isShowLoginIndexTwo = true
    // 	this.addRecord('END')
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    // //重练-登录
    // restartStudyFirst() {
    // 	this.initFirst()
    // 	$('#studytip-'+this.tabCurrent).hide();
    // 	this.addRecord('START')
    // },
    //第2步-
    showLoginnr1_1() {
    	this.isShownr1_1=false
    	this.isShownr1_2=true
		this.getFocus()
    },
	//input自动获取焦点1
	getFocus(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname.focus();
			}, 100);
		})
	},

	//监听回车1
	listenOne(event) {
	    if(event.keyCode === 13) {
		this.verification_nr1()
        event.preventDefault()
        return false
	    }
		},
	verification_nr1(){
		if(this.nr_input=='总分较8月上升（下降）'){
			this.isShownr1_2=false
    		this.isShownr1_3=true
			console.log(22222)
			setTimeout(()=>{
			this.isShownr1_3_1=true
			},2000)
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
	},
	//点击A3
	showLoginnr1_3(){
	    this.isShownr1_3=false

		this.isShownr1_4=true
		this.getFocus2()
	},
	//input自动获取焦点2
	getFocus2(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname2.focus();
			}, 100);
		})
	},
	//监听回车2
	listenTwo(event){
    console.log(event,7777)
	console.log(event.key,555)
	if( event.key== ';' && event.ctrlKey) {
		    this.isShownr1_4=false
		    this.isShownr1_5=true
		    this.nr_input2=this.getNowDate()
			console.log(this.nr_input2,11111)
		    event.preventDefault()
		    return false
		    }
	},
	//监听回车3
	listenTwo_1(event){
		if(event.keyCode===13){
			if(this.nr_input2=='2022/9/29'){
				this.isShownr1_5=false
				this.isShownr1_6=true
			setTimeout(()=>{
				this.isShownr1_6_1=true
			},2000)
			}else{
				this.notify('<p>请按照右边提示填写正确的内容</p>')
			}
		}

	// if(  ) {
	// 	    this.isShownr1_4=false
	// 	    this.isShownr1_5=true
	// 	    this.nr_input2=this.getNowDate()
	// 		console.log(this.nr_input2,77777)
	// 	    event.preventDefault()
	// 	    return false
	// 	    }
	},
	// 获得当前时间（并格式化）
	getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}/${month}/${day}`
      return NOW_MONTHS_AGO
    },
	// 点击A单元格（下拖前）
    showLoginnr1_6(){
		this.isShownr1_6=false
		this.isShownr1_6_1=false
		this.isShownr1_7=true
        // this.getFocus3()
	},

	//input自动获取焦点3
	getFocus3(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname3.focus();
			}, 100);
		})
	},
	//监听ctrl+C
	listenTwo_2(event){
    console.log(event,7777)
	if( event.keyCode== 67 && event.ctrlKey ) {
		    this.showLoginnr1_7()
            event.preventDefault()
		    return false
		    }
	},
	// 按下 ctrl C
    showLoginnr1_7(){
		this.isShownr1_7=false
		this.isShownr1_8=true
		setTimeout(() => {
			this.isShownr1_8=false
			this.isShownr1_9=true
			// this.getFocus4()
		}, 1000);




	},
	//监听Ctrl+v 4
	// listenTwo_3(event){
    // console.log(event,77778888)
	// if( event.keyCode== 86) {
	// 	    this.isShownr1_9=false
	// 	    this.isShownr1_10=true
    //         setTimeout(()=>{
	// 			this.isShownr1_10=false
	// 			this.isShownr1_11=true
	// 		},2000)
    //         event.preventDefault()
	// 	    return false
	// 	    }
	// },
	//监听Ctrl+v 4
	listenTwo_3(){
		    this.isShownr1_9=false
		    this.isShownr1_10=true
            setTimeout(()=>{
				this.isShownr1_10=false
				this.isShownr1_11=true
			},2000)
	},
	//input自动获取焦点4
	getFocus4(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname4.focus();
			}, 100);
		})
	},
	//点击C列
	showLoginnr1_11(){
       this.isShownr1_11=false
       this.isShownr1_12=true
	},
	//点击鼠标右键
	rightClick($event){
		this.isShownr1_12=false
		this.isShownr1_13=true
	},
	//右键后鼠标移入插入列
	showLoginnr1_13(){
		this.isShownr1_13=false
		this.isShownr1_14=true
	},
	//点击鼠标移入的插入列
	showLoginnr1_14(){
		this.isShownr1_14=false
		this.isShownr1_15=true
		setTimeout(() => {
			this.isShownr1_15=false
        	this.isShownr1_16=true
		}, 2000);
	},
	//点击第6列
	showLoginnr1_15(){
		this.isShownr1_16=false
        this.isShownr1_17=true
	},
	//点击右键
	showLoginnr1_16(){
		// this.isShownr1_17=false
        // this.isShownr1_17_1=true
		this.isShownr1_17_1=true
	},
	//鼠标移入
	showLoginnr1_17(){
		this.isShownr1_17_1=false
		this.isShownr1_17_2=true
	},
	//点击插入行
	showLoginnr1_17_1(){
		this.isShownr1_17=false
		this.isShownr1_17_2=false
		this.isShownr1_18=true
		//过渡求和
		setTimeout(() => {
			this.isShownr1_18=false
			this.isShownr1_19=true
		}, 2000);
	},
	// 求和

	//点击I3
	showLoginnr1_19(){
		this.isShownr1_19=false
		this.isShowqh1_1=true
		this.getFocusqh_1()
	},
	//点击F3
	showLoginnr1_20(){
		if(this.qh1_input=='='){
			this.qh1_input1='=F3'
			this.isShowqh1_1=false
			this.isShowqh1_2=true
			this.getFocusqh_2()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	//直接复制=F3+G3+H3
	showLoginnr1_20_1(){
		if(this.qh1_input=='=F3+G3+H3'){

			this.isShowqh1_1=false
			this.isShowqh1_5=true
			 //平均值页面
			setTimeout(() => {
				this.isShowqh1_5=false
				this.isShowpj1_1=true
			}, 2000);

		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	//点击G3
	showLoginqh1_2(){
		if(this.qh1_input1=='=F3+'){
		this.qh1_input='=F3+G3'
		this.isShowqh1_2=false
		this.isShowqh1_3=true
		this.getFocusqh_1()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	//点击H3
	showLoginqh1_3(){
		if(this.qh1_input=='=F3+G3+'){
		this.isShowqh1_3=false
		this.isShowqh1_4=true
		// this.getFocusqh_1()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	//输入框焦点聚焦
	getFocusqh_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_1qh.focus();
			}, 100);
		})
	},
	//输入框焦点聚焦
	getFocusqh_2(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_2qh.focus();
			}, 100);
		})
	},
	//敲下enter
	showLoginqh1_4(event){
       this.isShowqh1_4=false
       this.isShowqh1_5=true
	   //平均值页面
       setTimeout(() => {
		   this.isShowqh1_5=false
		   this.isShowpj1_1=true
	   }, 2000);
	},
	//点击J3
	Loginpj1_1(){
		this.isShowpj1_1=false
		this.isShowpj1_2=true
		this.getFocuspj_1()
	},
	//输入框焦点聚焦
	getFocuspj_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_pj1.focus();
			}, 100);
		})
	},
	//点击I3
	Loginpj1_2(){
		if(this.pj1_input=='='){
			this.pj1_input='=I3'
			this.isShowpj1_2=false
			this.isShowpj1_3=true
			this.getFocuspj_1()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

		// this.getFocuspj_1()
	},
	//直接复制=I3/3
	Loginpj1_2_1(){
		if(this.pj1_input=='=I3/3'){
			this.isShowpj1_2=false
			this.isShowpj1_4=true
			setTimeout(() => {
				this.isShowpj1_4=false
				this.isShowzf1_1=true
			}, 2000);

		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
	},

	//按下enter
	showLoginpj1_1(){
		if(this.pj1_input=='=I3/3'){
			this.isShowpj1_3=false
			this.isShowpj1_4=true
		// 总分页面显示
			setTimeout(() => {
				this.isShowpj1_4=false
				this.isShowzf1_1=true
			}, 2000);
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	//点击K3单元格
	Loginzf1_1(){
		this.isShowzf1_1=false
		this.isShowzf1_2=true
		this.getFocuszf_1()
	},
	//点击I3单元格
	Loginzf1_2(){
		if(this.zf1_input=='='){
			this.zf1_input='=I3'
			this.isShowzf1_2=false
			this.isShowzf1_3=true
			this.getFocuszf_1()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	//直接复制=I3-E3
	Loginzf1_2_1(){
		if(this.zf1_input=='=I3-E3'){

			this.isShowzf1_2=false
			this.isShowzf1_5=true
			setTimeout(()=>{
				this.isShowzf1_5=false
				this.isShowxg1_1=true
		},2000)

		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
		//输入框焦点聚焦
	getFocuszf_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_zf1.focus();
			}, 100);
		})
	},
	//点击E3单元格
	Loginzf1_3(){
		if(this.zf1_input=='=I3-'){
			this.zf1_input='I3-E3'
			this.isShowzf1_3=false
			this.isShowzf1_4=true
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

		// this.getFocuszf_1()
	},
	//按下enter
	showLoginzf1_1(){

		this.isShowzf1_4=false
		this.isShowzf1_5=true
		// 显示修改页面
		setTimeout(()=>{
			this.isShowzf1_5=false
			this.isShowxg1_1=true
		},2000)
	},
	//输入框焦点聚焦
	getFocusxg_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_xg1.focus();
			}, 100);
		})
	},
	// 点击下方的名字，进行修改
    Loginxg1_3(){
        this.isShowxg1_1=false
		this.isShowxg1_2=true
    },
	//修改完点击enter
	showLoginxg1_1(){
    if(this.xg_input1=='成绩汇总'){
		this.isShowxg1_2=false
		this.isShowxg1_3=true
		// 显示新建页面
		setTimeout(() => {
			this.isShowxg1_3=false
			this.isShowxj1_1=true
		}, 2000);
	}else{
		this.notify('<p>请按照右边提示填写正确的内容</p>')
	}
	},
	// 移入+号
	Loginxj1_1(){
		this.isShowxj1_1=false
		this.isShowxj1_2=true
	},
	// 点击+号
	Loginxj1_2(){
		this.isShowxj1_2=false
		this.isShowxj1_3=true
		// 显示占比页面
		setTimeout(() => {
			this.isShowxj1_3=false
			this.isShowzb1_1=true
		}, 2000);
	},
	//点击C3
	Loginzb1_1(){
		this.isShowzb1_1=false
		this.isShowzb1_2=true
		this.getFocuszb_1()
	},
	// 点击B3
	Loginzb1_2(){
		if(this.zb_input1=='='){
			this.zb_input1='=B3'
			this.isShowzb1_2=false
			this.isShowzb1_3=true
			this.getFocuszb_1()
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	// 直接复制=B3/A3
	Loginzb1_2_1(){
		if(this.zb_input1=='=B3/A3'){

			this.isShowzb1_2=false
			this.isShowzb1_5=true
			setTimeout(()=>{
				this.isShowzb1_5=false
				this.isShowxg2_1=true
		},2000)
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

	},
	//输入框焦点聚焦
	getFocuszb_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_zb1.focus();
			}, 100);
		})
	},

	//点击A3
	Loginzb1_3(){
		if(this.zb_input1=='=B3/'){
			this.isShowzb1_3=false
			this.isShowzb1_4=true

		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}

		// this.getFocuszb_1()
	},
	//按下enter
	showLoginzb1_1(){
		this.isShowzb1_4=false
		this.isShowzb1_5=true
		//第二张修改页面
		setTimeout(()=>{
			this.isShowzb1_5=false
			this.isShowxg2_1=true
		},2000)
	},
	//输入框焦点聚焦
	getFocusxg_2(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_xg2.focus();
			}, 100);
		})
	},
	//点击下面的sheet2
	Loginxg2_1(){
		this.isShowxg2_1=false
		this.isShowxg2_2=true
		this.getFocusxg_2()
	},
	//按下enter
	showLoginxg2_1(){

        if(this.xg_input2=='数据统计'){
			var self = this
			this.isShowxg2_2=false
			this.isShowxg2_3=true
			this.addRecord('END')
			setTimeout(function() {
			$('#studytip-'+self.tabCurrent).show();
      	}, 2000);
		}else{
			this.notify('<p>请按照右边提示填写正确的内容</p>')
		}
	},
    //重练-Excel内容编辑
    restartStudySecond() {
    	this.initSecond()
			$('#studytip-'+this.tabCurrent).hide();
			this.addRecord('START')
    },

    // 第3步-Excel内容布局

	//鼠标移入字体样式
    Loginzt1_1(){
        this.isShowzt1_1=false
		this.isShowzt1_2=true
	},
	//鼠标点击字体样式
	Loginzt1_2(){
		this.isShowzt1_2=false
		this.isShowzt1_3=true
	},
	//鼠标移入微软雅黑
	Loginzt1_3(){
		this.isShowzt1_3=false
		this.isShowzt1_4=true
		// this.isShowzt1_3=true
	},
	//鼠标点击微软雅黑
	Loginzt1_4(){
		this.isShowzt1_4=false
		this.isShowzt1_5=true
		// 显示居中页面
		setTimeout(()=>{
			this.isShowzt1_5=false
			this.isShowjz1_1=true
		},2000)
	},
	//鼠标移入居中
	Loginjz1_1(){
		this.isShowjz1_1=false
		this.isShowjz1_2=true
	},
	//鼠标点击居中
	Loginjz1_2(){
		this.isShowjz1_2=false
		this.isShowjz1_3=true
		// 显示框线页面
		setTimeout(() => {
			this.isShowjz1_3=false
			this.isShowkx1_1=true
		}, 2000);
	},
    // 鼠标移入框线
	Loginkx1_1(){
		this.isShowkx1_1=false
		this.isShowkx1_2=true
	},
	//鼠标点击框线
	Loginkx1_2(){
		this.isShowkx1_2=false
		this.isShowkx1_3=true
	},
	//鼠标移入所有框线
	Loginkx1_3(){
		this.isShowkx1_3=false
		this.isShowkx1_4=true
	},
	//鼠标点击所有框线
	Loginkx1_4(){
		this.isShowkx1_4=false
		this.isShowkx1_5=true
		// 调整A页面显示
		setTimeout(() => {
			this.isShowkx1_5=false
			this.isShowta1_2=true
		}, 2000);
	},
	// //点击A列
	// Loginta1_1(){
	// 	this.isShowta1_1=false
	// 	this.isShowta1_2=true
	// },
	//鼠标移入ab列间
	Loginta1_2(v){
    console.log('11111111111111111111111111',v)
		this.isShowta1_2=false
		this.isShowta1_3=true
		// 显示加粗合并第一行页面
		setTimeout(() => {
			this.isShowta1_3=false
			this.isShowjchb1_1=true
		}, 2000);

	},
	//鼠标移入字体加粗
	Loginjchb1_1(){
		this.isShowjchb1_1=false
		this.isShowjchb1_2=true
	},
	//鼠标点击字体加粗（第一次）
	Loginjchb1_2(){
		this.isShowjchb1_2=false
		this.isShowjchb1_3=true
	},
	//鼠标点击字体加粗（第二次）
	Loginjchb1_3(){
		this.isShowjchb1_3=false
		this.isShowjchb1_4=true
	},
	//鼠标移入加粗
	Loginjchb1_4(){
		this.isShowjchb1_4=false
		this.isShowjchb1_5=true
	},
	//鼠标点击加粗
	Loginjchb1_5(){
		this.isShowjchb1_5=false
		this.isShowjchb1_6=true
	},
	//鼠标移入合并居中
	Loginjchb1_6(){
		this.isShowjchb1_6=false
		this.isShowjchb1_7=true
	},
	//鼠标点击合并居中
	Loginjchb1_7(){
		this.isShowjchb1_7=false
		this.isShowjchb1_8=true
	},
    //鼠标移入设置颜色
	Loginjchb1_8(){
		this.isShowjchb1_8=false
		this.isShowjchb1_9=true
	},
    //鼠标点击设置颜色
	Loginjchb1_9(){
		this.isShowjchb1_9=false
		this.isShowjchb1_10=true
	},
    //鼠标移到颜色
	Loginjchb1_10(){
		this.isShowjchb1_10=false
		this.isShowjchb1_11=true
	},
    //鼠标点击颜色
	Loginjchb1_11(){
		this.isShowjchb1_11=false
		this.isShowjchb1_12=true
		//第二行颜色换行页面显示
		setTimeout(() => {
			this.isShowjchb1_12=false
			this.isShowyshh1_1=true
		}, 2000);
	},
    //鼠标移入字体颜色的A
	Loginyshh1_1(){
        this.isShowyshh1_1=false
		this.isShowyshh1_2=true
	},
    //鼠标点击字体颜色的A
	Loginyshh1_2(){
        this.isShowyshh1_2=false
		this.isShowyshh1_3=true
	},
	//鼠标移到自动换行
	Loginyshh1_3(){
		this.isShowyshh1_3=false
		this.isShowyshh1_4=true
	},
	//鼠标点击自动换行
	Loginyshh1_4(){
		this.isShowyshh1_4=false
		this.isShowyshh1_5=true
		// 显示冻结页面
		setTimeout(() => {
			this.isShowyshh1_5=false
			this.isShowdj1_1=true
		}, 2000);
	},
    //鼠标移入冻结窗格
	Logindj1_1(){
		this.isShowdj1_1=false
		this.isShowdj1_2=true
	},
    //鼠标点击冻结窗格
	Logindj1_2(){
		this.isShowdj1_2=false
		this.isShowdj1_3=true
	},
    //鼠标移入冻结至第二行
	Logindj1_3(){
		this.isShowdj1_3=false
		this.isShowdj1_4=true
	},
    //鼠标点击冻结至第二行
	Logindj1_4(){
		this.isShowdj1_4=false
		this.isShowdj1_5=true
		// 保留小数页面显示
		setTimeout(() => {
			this.isShowdj1_5=false
			this.isShowxs1_1=true
		}, 2000);

	},
	//鼠标移入常规
	Loginxs1_1(){
		this.isShowxs1_1=false
		this.isShowxs1_2=true
	},
	//鼠标点击常规下箭头
	Loginxs1_2(){
		this.isShowxs1_2=false
		this.isShowxs1_3=true
	},
	//鼠标移入其他数字格式
	Loginxs1_3(){
		this.isShowxs1_3=false
		this.isShowxs1_4=true
	},
	//鼠标点击其他数字格式
	Loginxs1_4(){
		this.isShowxs1_4=false
		this.isShowxs1_5=true
	},
	// 点击数值
	Loginxs1_5(){
		this.isShowxs1_5=false
		this.isShowxs1_6=true
	},
	// 鼠标移入输入框
	Loginxs1_6(){
		this.isShowxs1_6=false
		this.isShowxs1_7=true
	},
	// 鼠标点击减号输入框
	Loginxs1_7(){
		this.isShowxs1_7=false
		this.isShowxs1_8=true
	},
	// 鼠标移动到确定
	Loginxs1_8(){
		this.isShowxs1_8=false
		this.isShowxs1_9=true
	},
	// 鼠标点击确定
	Loginxs1_9(){
		this.isShowxs1_9=false
		this.isShowxs1_10=true
		// 占比保留页面显示
		setTimeout(() => {
			this.isShowxs1_10=false
			this.isShowzbbl1_1=true
		},2000);
	},
	//鼠标移入常规
	Loginzbbl1_1(){
		this.isShowzbbl1_1=false
		this.isShowzbbl1_2=true
	},
	//鼠标点击常规
	Loginzbbl1_2(){
		this.isShowzbbl1_2=false
		this.isShowzbbl1_3=true
	},
	//鼠标移动到%
	Loginzbbl1_3(){
		this.isShowzbbl1_3=false
		this.isShowzbbl1_4=true
	},
	//鼠标移动到%
	Loginzbbl1_4(){
		this.isShowzbbl1_3=false
		this.isShowzbbl1_4=true
	},
	//鼠标点击%
	Loginzbbl1_4(){
		let self = this
		this.isShowzbbl1_4=false
		this.isShowzbbl1_5=true
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	//重练第三步-Excel内容布局
    restartStudyThird() {
    	this.initThird()
			$('#studytip-'+this.tabCurrent).hide();
			this.addRecord('START')
    },
	// 第四步 保存文件
	//输入框焦点聚焦
	getFocusbc_1(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_bc1.focus();
			}, 100);
		})
	},
    // // 监听etrl+s
	// showLoginbc1_1(event){

    // console.log(event,77778888)
	// if( event.keyCode== 83) {

	// 	    this.isShowbc1_1=false
	// 	    this.isShowbc1_2=true

    //         event.preventDefault()
	// 	    return false
	// 	    }
	// },
    // 监听etrl+s
	showLoginbc1_1(event){

		this.isShowbc1_1=false
		this.isShowbc1_2=true


	},
	// 鼠标移入我的桌面
	Loginbc1_1(){
		this.isShowbc1_2=false
		this.isShowbc1_3=true
	},
	// 鼠标移入我的桌面
	Loginbc1_2(){
		this.isShowbc1_3=false
		this.isShowbc1_4=true
	},
	// 鼠标移入办公软件培训
	Loginbc1_3(){
		this.isShowbc1_4=false
		this.isShowbc1_5=true
	},
	// 鼠标点击办公软件培训
	Loginbc1_4(){
		this.isShowbc1_5=false
		this.isShowbc1_6=true
	},
	// 鼠标点击文件名
	Loginbc1_5(){
		this.isShowbc1_6=false
		this.isShowbc1_7=true
	},
	//输入框焦点聚焦
	getFocusbc_2(){
		this.$nextTick(function() {
			if (this.timer) {
			clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
			this.$refs.strname_bc2.focus();
			}, 100);
		})
	},
	//第二次点击文件名
	Loginbc1_6(){
		this.isShowbc1_7=false
		this.isShowbc1_8=true
		this.getFocusbc_2()
	},
	// 鼠标点击文件名
	Loginbc1_7(){
		if(this.bc_input2=='月考成绩统计'){
			this.isShowbc1_8=false
			this.isShowbc1_9=true
			//显示另存页面
			setTimeout(() => {
				this.isShowbc1_9=false
				this.isShowlc1_1=true
			}, 2000);
		}else{
			this.notify('<p>请填写月考成绩统计</p>')
		}

	},
	// 监听另存点击右键
	Loginlc1_1(){
		console.log(8899)
		this.isShowlc1_1=false
		this.isShowlc1_2=true
	},
	//鼠标移入另存为
	Loginlc1_2(){
		this.isShowlc1_2=false
		this.isShowlc1_3=true
	},
	//鼠标点击另存为
	Loginlc1_3(){
		this.isShowlc1_3=false
		this.isShowlc1_4=true
	},
	//鼠标移入我的桌面
	Loginlc1_4(){
		this.isShowlc1_4=false
		this.isShowlc1_5=true
	},
	//鼠标点击我的桌面
	Loginlc1_5(){
		this.isShowlc1_5=false
		this.isShowlc1_6=true
	},
	//鼠标点击保存
	Loginlc1_6(){
		var self = this
		this.isShowlc1_6=false
		this.isShowlc1_7=true
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	//重练第4步-保存文件
    restartStudyFour() {
    	this.initFour()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
	//第五步保存文件
	// 鼠标移入关闭
	Loginfs1_1(){
		this.isShowfs1_1=false
		this.isShowfs1_2=true
	},
	// 鼠标移入关闭
	Loginfs1_1(){
		this.isShowfs1_1=false
		this.isShowfs1_2=true
	},
	// 鼠标点击关闭
	Loginfs1_2(){
		this.isShowfs1_2=false
		this.isShowfs1_3=true
	},
	// 鼠标点击表格
	Loginfs1_3(){
		this.isShowfs1_3=false
		this.isShowfs1_4=true
	},
	// 按下etrl+c
	Loginfs1_4(){
		this.isShowfs1_4=false
		this.isShowfs1_5=true
	},
	// 按下etrl+v
	Loginfs1_5(){
		this.isShowfs1_5=false
		this.isShowfs1_6=true
	},
	// 点击发送
	Loginfs1_6(){
		var self = this
		this.isShowfs1_6=false
		this.isShowfs1_7=true
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
	},
	// 第六步
	//ctrl+A
	Loginwdzt1_1(){
		this.isShowwdzt1_1=false
		this.isShowwdzt1_2=true
	},
	//鼠标移入字体下拉
	Loginwdzt1_2(){
		this.isShowwdzt1_2=false
		this.isShowwdzt1_3=true
	},
	//鼠标点击字体下拉
	Loginwdzt1_3(){
		this.isShowwdzt1_3=false
		this.isShowwdzt1_4=true
	},
	//鼠标移入楷体
	Loginwdzt1_4(){
		this.isShowwdzt1_4=false
		this.isShowwdzt1_5=true
	},
	//鼠标点击楷体
	Loginwdzt1_5(){
		this.isShowwdzt1_5=false
		this.isShowwdzt1_6=true
	},
	//鼠标移入字号
	Loginwdzt1_6(){
		this.isShowwdzt1_6=false
		this.isShowwdzt1_7=true
	},
	//鼠标点击字号
	Loginwdzt1_7(){
		this.isShowwdzt1_7=false
		this.isShowwdzt1_8=true
	},
	//鼠标移入小四
	Loginwdzt1_8(){
		this.isShowwdzt1_8=false
		this.isShowwdzt1_9=true
	},
	//鼠标点击小四
	Loginwdzt1_9(){
		this.isShowwdzt1_9=false
		this.isShowwdzt1_10=true
	},
	//鼠标点击小四
	Loginwdzt1_9(){
		this.isShowwdzt1_9=false
		this.isShowwdzt1_10=true
		// 显示行距页面
		setTimeout(() => {
			this.isShowwdzt1_10=false
			this.isShowwdhj1_1=true
		}, 2000);
	},
	// 移入行距
	Loginwdhj1_1(){
		this.isShowwdhj1_1=false
		this.isShowwdhj1_2=true
	},
	// 点击行距
	Loginwdhj1_2(){
		this.isShowwdhj1_2=false
		this.isShowwdhj1_3=true
	},
	// 鼠标移入1.5
	Loginwdhj1_3(){
		this.isShowwdhj1_3=false
		this.isShowwdhj1_4=true
	},
	// 鼠标点击1.5
	Loginwdhj1_4(){
		this.isShowwdhj1_4=false
		this.isShowwdhj1_5=true
		// 显示首行缩进页面
		setTimeout(() => {
			this.isShowwdhj1_5=false
			this.isShowwdsj1_1=true
		}, 2000);
	},
	// 点击鼠标右键
	rightClick_sj(){
		this.isShowwdsj1_1_1=true
	},
	//鼠标移入段落
	Loginwdsj1_1(){
		this.isShowwdsj1_1=false
		this.isShowwdsj1_2=true
	},
	//鼠标点击段落
	Loginwdsj1_2(){
		this.isShowwdsj1_2=false
		this.isShowwdsj1_3=true
	},
	//鼠标点击特殊格式
	Loginwdsj1_3(){
		this.isShowwdsj1_3=false
		this.isShowwdsj1_4=true
	},
	//鼠标移动到首行缩进
	Loginwdsj1_4(){
		this.isShowwdsj1_4=false
		this.isShowwdsj1_5=true
	},
	//鼠标点击首行缩进
	Loginwdsj1_5(){
		this.isShowwdsj1_5=false
		this.isShowwdsj1_6=true
	},
	//鼠标点击确定
	Loginwdsj1_6(){
		this.isShowwdsj1_6=false
		this.isShowwdsj1_7=true
		// 显示加粗居中页面
		setTimeout(() => {
			this.isShowwdsj1_7=false
			this.isShowwdjc1_1=true
		}, 2000);
	},
	// 鼠标移到加粗
	Loginwdjc1_1(){
		this.isShowwdjc1_1=false
		this.isShowwdjc1_2=true
	},
	// 鼠标点击加粗
	Loginwdjc1_2(){
		this.isShowwdjc1_2=false
		this.isShowwdjc1_3=true
	},
	// 鼠标移到居中
	Loginwdjc1_3(){
		this.isShowwdjc1_3=false
		this.isShowwdjc1_4=true
	},
	// 鼠标点击居中
	Loginwdjc1_4(){
		this.isShowwdjc1_4=false
		this.isShowwdjc1_5=true
		// 设置颜色页面显示
		setTimeout(() => {
			this.isShowwdjc1_5=false
			this.isShowwdys1_1=true
		}, 2000);
	},
	// 鼠标移到颜色
	Loginwdys1_1(){
		this.isShowwdys1_1=false
		this.isShowwdys1_2=true
	},
	// 鼠标点击颜色
	Loginwdys1_2(){
		this.isShowwdys1_2=false
		this.isShowwdys1_3=true
	},
	// 鼠标移到红色
	Loginwdys1_3(){
		this.isShowwdys1_3=false
		this.isShowwdys1_4=true
	},
	// 鼠标点击红色
	Loginwdys1_4(){
		this.isShowwdys1_4=false
		this.isShowwdys1_5=true
		// 自然段颜色页面显示
		setTimeout(() => {
			this.isShowwdys1_5=false
			this.isShowwdtx1_1=true
		}, 2000);
	},
	//鼠标移入段落颜色
	Loginwdtx1_1(){
		this.isShowwdtx1_1=false
		this.isShowwdtx1_2=true
	},
	//鼠标点击段落颜色
	Loginwdtx1_2(){
		this.isShowwdtx1_2=false
		this.isShowwdtx1_4=true
		let self = this
		this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
		// this.isShowwdtx1_3=true
	},
	//鼠标点击空白
	Loginwdtx1_3(){
	// 	let self = this
	// 	this.isShowwdtx1_3=false
	// 	this.isShowwdtx1_4=true
	// 	this.addRecord('END')
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
	},
	// 重新练习Word基础功能
	 restartStudySix() {
    	this.initSix()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
	// //鼠标点击保存
	// Loginlc1_4(){
	// 	this.isShowlc1_5=false
	// 	this.isShowlc1_6=true
	// },
	// //鼠标点击常规下箭头
	// Loginxs1_3(){
	// 	this.isShowxs1_2=false
	// 	this.isShowxs1_3=true
	// },
    //监听回车1

		//监听回车3
		listenThree() {
			if(event.keyCode === 13) {
        this.showJieDaiImgThree()
        event.preventDefault()
        return false
	    }
		},
		//监听回车4
		listenFour() {
			if(event.keyCode === 13) {
        this.showJieDaiImgFour()
        event.preventDefault()
        return false
	    }
		},
    //接待顾客-显示回复1
    showJieDaiImgOne() {
    	let self = this
    	if(this.jdnr.indexOf('您好')<0 || this.jdnr.indexOf('欢迎光临')<0 || this.jdnr.indexOf('请问有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time1 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time2 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p>";
        $('.replyone').html(self.replyhtml);
        setTimeout(function() {
        	self.isShowOne = false
    			self.isShowTwo = true
        }, 500);
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复2
    showJieDaiImgTwo() {
    	let self = this
    	if(this.jdnr.indexOf('亲亲')<0 || this.jdnr.indexOf('正常情况下大概3天左右能到哦')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time3 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time4 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p>";
        $('.replyone').html(self.replyhtml);
        setTimeout(function() {
        	self.isShowTwo = false
    			self.isShowThree = true
        }, 500);
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复3
    showJieDaiImgThree() {
    	let self = this
    	if(this.jdnr.indexOf('请问还有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time5 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function() {
      	self.time6 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time6+"</span></p><p><span>没有了</span></p>";
        $('.replyone').html(self.replyhtml);
        setTimeout(function() {
        	self.isShowThree = false
    			self.isShowFour = true
        }, 500);
      }, 2000);
    	this.jdnr = ''
    },
    //接待顾客-显示回复4
    showJieDaiImgFour() {
    	let self = this
    	if(this.jdnr.indexOf('好的')<0 || this.jdnr.indexOf('感谢亲亲的支持')<0 || this.jdnr.indexOf('祝您生活愉快')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
      this.time7 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time6+"</span></p><p><span>没有了</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time7+"</span></p><p><span>好的，感谢亲亲的支持，祝您生活愉快</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
    	this.jdnr = ''
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第三步-接待顾客
    restartStudyThird() {
    	this.initThird()
			$('#studytip-'+this.tabCurrent).hide();
			this.addRecord('START')
    },
    //第4步-自动回复
    showZdhf01() {
    	this.isShowZdhficon = false
    	this.isShowZdhf01 = true
    	var $zdhficon = $('.zdhficon').closest('.con-left'),
        	height = $('.zdhficon').closest('.con-left')[0].scrollHeight;
    	setTimeout(() => {
        $zdhficon.scrollTop(height)
      }, 100)
    },
    showZdhf02() {
    	this.isShowZdhf01 = false
    	this.isShowZdhf02 = true
    },
    showZdhf03() {
    	this.isShowZdhf02 = false
    	this.isShowZdhf03 = true
    },
    showZdhf04() {
    	this.isShowZdhf03 = false
    	this.isShowZdhf04 = true
    },
    showZdhf05() {
    	this.isShowZdhf04 = false
    	this.isShowZdhf05 = true
    },
    showZdhf06() {
    	if(this.zdhf.indexOf('您好')<0 || this.zdhf.indexOf('欢迎光临')<0 || this.zdhf.indexOf('请问有什么可以帮到您')<0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>')
        return
      }
    	this.isShowZdhf05 = false
    	this.zdhf = ''
    	this.isShowZdhf06 = true
    },
    showZdhf07() {
    	this.isShowZdhf06 = false
    	this.isShowZdhf07 = true
    },
    showZdhf08() {
    	this.isShowZdhf07 = false
    	this.isShowZdhf08 = true
    },
    showZdhf09() {
    	this.isShowZdhf08 = false
    	this.isShowZdhf09 = true
    },
    showZdhf10() {
    	let self = this
    	this.isShowZdhf09 = false
    	this.isShowZdhf10 = true
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第4步-自动回复
    restartStudyFour() {
    	this.initFour()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第5步-插件学习
    // showCjxx01() {
    // 	this.isShowCjxxicon = false
    // 	this.isShowCjxx01 = true
    // },
    // showCjxx02() {
    // 	this.isShowCjxx01 = false
    // 	this.isShowCjxx02 = true
    // },
    // showCjxx03() {
    // 	this.isShowCjxx02 = false
    // 	this.isShowCjxx03 = true
    // 	this.isShowCjxxTip = false
    // 	this.isShowCjxxTip01 = true
    // },
    // showCjxx04() {
    // 	this.isShowCjxx03 = false
    // 	this.isShowCjxx04 = true
    // },
    // showCjxx05() {
    // 	this.isShowCjxx04 = false
    // 	this.isShowCjxx05 = true
    // },
    // showCjxx06() {
    // 	this.isShowCjxx05 = false
    //   this.isShowCjxx06 = true
    // },
    // showCjxx07() {
    // 	this.isShowCjxx06 = false
    //   this.isShowCjxx07 = true
    // },
    // showCjxx08() {
    // 	this.isShowCjxx07 = false
    // 	this.isShowCjxx08 = true
    // },
    // showCjxx09() {
    // 	this.isShowCjxx08 = false
    // 	this.isShowCjxx09 = true
    // },
    // showCjxx10() {
    // 	this.isShowCjxx09 = false
    //   this.isShowCjxx10 = true
    // },
    // showCjxx11() {
    // 	this.isShowCjxx10 = false
    // 	this.isShowCjxx11 = true
    // },
    // showCjxx12() {
    // 	this.isShowCjxx11 = false
    // 	this.isShowCjxx12 = true
    // },
    // showCjxx13() {
    // 	this.isShowCjxx12 = false
    // 	this.isShowCjxx13 = true
    // },
    // showCjxx14() {
    // 	this.isShowCjxx13 = false
    //   this.isShowCjxx14 = true
    // },
    // showCjxx15() {
    // 	this.isShowCjxx14 = false
    // 	this.isShowCjxx15 = true
    // },
    // showCjxx16() {
    // 	this.isShowCjxx15 = false
    // 	this.isShowCjxx16 = true
    // },
    // showCjxx17() {
    // 	this.isShowCjxx16 = false
    // 	this.isShowCjxx17 = true
    // },
    // showCjxx18() {
    // 	this.isShowCjxx17 = false
    // 	this.isShowCjxx18 = true
    // 	this.isShowCjxxTip01 = false
    // 	this.isShowCjxxTip02 = true
    // },
    // showCjxx19() {
    // 	this.isShowCjxx18 = false
    // 	this.isShowCjxx19 = true
    // },
    // showCjxx20() {
    // 	this.isShowCjxx19 = false
    //   this.isShowCjxx20 = true
    //   let self = this;
    //   this.addRecord('END')
    //   setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    //重练第5步-添加插件
    restartStudyFive() {
    	this.initFive()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第6步-快捷短语
    showKjdy01() {
    	this.isShowKjdyicon = false
    	this.isShowKjdy01 = true
    },
    showKjdy02() {
    	this.isShowKjdy01 = false
    	this.isShowKjdy02 = true
    },
    showKjdy03() {
    	this.isShowKjdy02 = false
    	this.isShowKjdy03 = true
    },
    showKjdy04() {
    	let self = this
    	this.isShowKjdy03 = false
    	this.isShowKjdy04 = true
    	this.notify('<p>快捷短语鼠标点击练习完成，下一步快捷短语编码练习</p>')
    	setTimeout(function() {
        self.isShowKjdyTip01 = false
        self.isShowKjdyTip02 = true
        self.isShowKjdy04 = false
        self.isShowKjdy05 = true
      }, 2000);
    },
    showKjdy05() {
    	this.isShowKjdy05 = false
    	this.isShowKjdy06 = false
    	this.isShowKjdy07 = true
    },
    showKjdy06() {
    	let self = this
    	this.isShowKjdy07 = false
    	this.isShowKjdy08 = true
    	this.notify('<p>快捷短语编码练习完成，下一步快捷模板导入练习</p>')
    	setTimeout(function() {
        self.isShowKjdyTip02 = false
        self.isShowKjdyTip03 = true
        self.isShowKjdy08 = false
    		self.isShowKjdy09 = true
      }, 2000);
    },
    downloadKjdyFile() {
    	this.downCount = 1
    	// indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
		 let path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'
      const downloadRes = async () => {
          let response = await fetch(path);
          let blob = await response.blob();
          let objectUrl = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = objectUrl;
          a.download = '快捷短语.csv';
          a.click()
          a.remove();
       }
      downloadRes();

    	this.isShowKjdyTip03 = false
    	this.isShowKjdyTip04 = true
    },
    showKjdy07() {
    	if(this.downCount == 0) {
    		this.$alert('请先下载快捷短语模板')
    		return false
    	}
    	this.isShowKjdy09 = false
    	this.isShowKjdy10 = true
    },
    tirggerFile($event) {
    	let self = this
      var file = $event.target.files;
    	if(!file[0] || file[0] && file[0].name.indexOf('快捷短语')<0) {
    		this.$alert('请选择你下载的“快捷短语.csv”模板文件')
    		return false
    	}
    	setTimeout(function() {
        self.isShowKjdy10 = false
        self.isShowKjdy11 = true
      }, 500);
    },
    showKjdy08() {
    	let self = this
    	this.isShowKjdy11 = false
    	this.isShowKjdy12 = true
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第6步-快捷短语
    restartStudySix() {
    	this.initSix()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第7步-状态识别
    showZtsb01() {
    	this.isShowZtsbicon = false
    	this.isShowZtsb01 = true
    },
    showZtsb02() {
    	this.isShowZtsb01 = false
      this.isShowZtsb02 = true
      this.isShowZtsbTip01 = false
      this.isShowZtsbTip02 = true
    },
    showZtsb03() {
    	this.isShowZtsb02 = false
      this.isShowZtsb03 = true
    },
    showZtsb04() {
    	this.isShowZtsb03 = false
      this.isShowZtsb04 = true
      this.isShowZtsbTip02 = false
      this.isShowZtsbTip03 = true
    },
    showZtsb05() {
    	this.isShowZtsb04 = false
      this.isShowZtsb05 = true
    },
    showZtsb06() {
    	this.isShowZtsb05 = false
      this.isShowZtsb06 = true
      let self = this
    	this.isShowKjdy11 = false
    	this.isShowKjdy12 = true
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第7步-状态识别
    restartStudySeven() {
    	this.initSeven()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第8步-转接功能
    showZjgn01() {
    	this.isShowZjgnicon = false
    	this.isShowZjgn01 = true
    },
    showZjgn02() {
    	this.isShowZjgn01 = false
      this.isShowZjgn02 = true
      this.isShowZjgnTip01 = false
      this.isShowZjgnTip02 = true
    },
    showZjgn03() {
    	this.isShowZjgn02 = false
      this.isShowZjgn03 = true
    },
    showZjgn04() {
    	this.isShowZjgn03 = false
      this.isShowZjgn04 = true
    },
    showZjgn05() {
    	this.isShowZjgn04 = false
      this.isShowZjgn05 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第8步-转接功能
    restartStudyEight() {
    	this.initEight()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第9步-商品插件（推荐功能）
    showTjgn01() {
    	this.isShowTjgnicon = false
    	this.isShowTjgn01 = true
    },
    showTjgn02() {
    	this.isShowTjgn01 = false
      this.isShowTjgn02 = true
    },
    showTjgn03() {
    	this.isShowTjgn02 = false
      this.isShowTjgn03 = true
    },
    showTjgn04() {
    	this.isShowTjgn03 = false
      this.isShowTjgn04 = true
    },
    showTjgn05() {
    	this.isShowTjgn04 = false
      this.isShowTjgn05 = true
    },
    showTjgn06() {
    	this.isShowTjgn05 = false
      this.isShowTjgn06 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第9步-商品插件
    restartStudyNine() {
    	this.initNine()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第10步-订单插件
    showDdcj01() {
    	this.isShowDdcjicon = false
    	this.isShowDdcj01 = true
    },
    showDdcj02() {
    	if(this.ddcjbz == '') {
    		this.notify('<p>你还没有填写订单备注</p>')
        return;
    	}
      if(this.ddcjbz != '顾客要求发顺丰') {
        this.notify('<p>请按照右边提示填写正确的订单备注</p>')
        return;
      }
    	this.isShowDdcj01 = false
      this.isShowDdcj02 = true
      this.isShowDdcjTip02 = false
      this.isShowDdcjTip03 = true
    },
    showDdcj03() {
    	this.isShowDdcj02 = false
      this.isShowDdcj03 = true
    },
    showDdcj04() {
    	this.isShowDdcj03 = false
      this.isShowDdcj04 = true
    },
    showDdcj05() {
    	if(this.ddcjdz == '') {
    		this.notify('<p>你还没有填写地址</p>')
        return;
    	}
		console.log(this.ddcjdz)

    //   if(this.ddcjdz != '双流区大林镇') {
    //     this.notify('<p>请按照右边提示填写正确的地址</p>')
    //     return;
    //   }
      if(this.ddcjdz == "双流区 大林镇" || this.ddcjdz == "双流区大林镇" ) {

      }else{
		   console.log(this.ddcjdz=='双流区 大林镇')
        this.notify('<p>请按照右边提示填写正确的地址</p>')
        return;
	  }
    	this.isShowDdcj04 = false
      this.isShowDdcj05 = true
    },
    showDdcj06() {
    	this.isShowDdcj05 = false
      this.isShowDdcj06 = true
    },
    showDdcj08() {
    	this.isShowDdcj10 = false
      this.isShowDdcj08 = true
    },
    showDdcj09() {
    	this.isShowDdcj08 = false
      this.isShowDdcj09 = true
    },
    showDdcj10() {
    	if(this.ddcjyf == '') {
    		this.notify('<p>你还没有填写邮费</p>')
        return;
    	}
      if(this.ddcjyf != '10') {
        this.notify('<p>请按照右边提示填写正确的邮费</p>')
        return;
      }
    	this.isShowDdcj09 = false
      this.isShowDdcjicon = true
      this.isShowDdcjTip01 = false
      this.isShowDdcjTip02 = true
    },
    showDdcj07() {
    	this.isShowDdcj06 = false
      this.isShowDdcj10 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第10步-订单插件
    restartStudyTen() {
    	this.initTen()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第11步-新建任务
    showXjrw01() {
    	this.isShowXjrwicon = false
    	this.isShowXjrw01 = true
    },
    showXjrw02() {
    	this.isShowXjrw01 = false
      this.isShowXjrw02 = true
    },
    showXjrw03() {
    	if(this.xjrwtxt.indexOf('此顾客有购买意向')<0 || this.xjrwtxt.indexOf('请继续跟进')<0) {
        this.notify('<p>请按照右边提示填写正确的任务内容</p>')
        return;
      }
    	this.isShowXjrw02 = false
      this.isShowXjrw03 = true
    },
    showXjrw04() {
    	this.isShowXjrw03 = false
      this.isShowXjrw04 = true
    },
    showXjrw05() {
    	this.isShowXjrw04 = false
      this.isShowXjrw05 = true
    },
    showXjrw06() {
      if(this.xjrwsj != this.xjrwmt) {
        this.notify('<p>请按照右边提示设置正确的时间</p>')
        return;
      }
    	this.isShowXjrw05 = false
      this.isShowXjrw06 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    //重练第11步-新建任务
    restartStudyEleven() {
    	this.initEleven()
      $('#studytip-'+this.tabCurrent).hide();
      this.addRecord('START')
    },
    //第12步-退出千牛
    showTcqn01() {
    	this.isShowTcqnicon = false
    	this.isShowTcqn01 = true
    },
    showTcqn02() {
    	this.isShowTcqn01 = false
      this.isShowTcqn02 = true
      this.isShowTcqnTip01 = false
      this.isShowTcqnTip02 = true
    },
    showTcqn03() {
    	this.isShowTcqn02 = false
      this.isShowTcqn03 = true
    },
    showTcqn04() {
    	this.isShowTcqn03 = false
      this.isShowTcqn04 = true
    },
    showTcqn05() {
    	this.isShowTcqn04 = false
      this.isShowTcqn05 = true
      setTimeout(() => {
        var $left = $('.tcqn05icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight)
      }, 100)
    },
    showTcqn06() {
    	this.isShowTcqn05 = false
      this.isShowTcqn06 = true
    },
    showTcqn07() {
    	this.isShowTcqn06 = false
    	this.isShowTcqn07 = true
    },
    showTcqn08() {
    	this.isShowTcqn07 = false
      this.isShowTcqn08 = true
    },
    showTcqn09() {
    	this.isShowTcqn08 = false
      this.isShowTcqn09 = true
    },
    showTcqn10() {
    	this.isShowTcqn09 = false
      this.isShowTcqn10 = true
      let self = this
    	this.addRecord('END')
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString (date, format) { // 时间格式化
      var date = new Date(date),
        o = {
          "M+" : date.getMonth() + 1,
          "d+" : date.getDate(),
          "h+" : date.getHours(),
          "m+" : date.getMinutes(),
          "s+" : date.getSeconds(),
          "q+" : Math.floor((date.getMonth() + 3) / 3),
          "S" : date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday(n){
      let lastDays = new Date().setDate((new Date().getDate() - n));
      let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord(type) {
      var data = {
        exerciseType: 'WPS_EXCEL',
        stepSeq: this.tabIndex,
        exerciseAction: type
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
        var result = res.data
        if(result.success) {
          if(this.tabIndex==7 && type=='END'){
		    window.parent['goBack']();
		  }
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      },res=> {
        this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    },
	inputnr1focus(){
		this.inputnr1=''
	}
  }
}
</script>
<style lang="less" scoped>
.account-table {
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
  margin: 10px;
  border-spacing: inherit;
  > tr > td {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding: 5px;
  }
}
// #newQianniu .content .qnbox{
// 	width: 1060px;
//     height: 650px;
//     position: relative;
// }
#newQianniu .content .qnbox .qnicon01{
	position: absolute;
    // top: calc(50% - 37px);
    // bottom: calc(50% - 37px);
    margin-top: -218px;
    // left: calc(50% - 38px);
    // right: calc(50% - 38px);
    margin-left: -285px;
    width: 98px;
    height: 98px;
}
// #newQianniu .content .qnbox .qnicon02
#newQianniu .content .qnbox  .qnicon02-1{
	width: 67px !important;
    height: 21px !important;
	top:216px;
	left:473px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;

	}
#newQianniu .content .qnbox  .qnicon04-1{
	width: 176px !important;
    height: 43px !important;
	top:486px;
	left:272px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;

	}
#newQianniu .content .qnbox  .qnicon05-1{
	width: 123px !important;
    height: 32px !important;
	top:491px;
	left:286px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;

	}
#newQianniu .content .qnbox  .qnicon06-1{
	width: 120px !important;
    height: 92px !important;
	top:389px;
	left:533px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;

	}
#newQianniu .content .qnbox  .qnicon09-1{
	width: 59px !important;
    height: 20px !important;
	top:399px;
	left:372px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#newQianniu .content .qnbox  .qnicon11-1{
	width: 23px !important;
    height: 12px !important;
	top:519px;
	left:260px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;

	}
#newQianniu .content .qnbox  .qnicon13-1{
	width: 69px !important;
    height: 15px !important;
	top:461px;
	left:367px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;

	}
// #content-second .qnbox .nr1-1{
// 	position:absolute;
// 	width: 71px !important;
//     height: 17px !important;
// 	top:351px;
// 	left:668px;
// 	cursor: pointer;
// 	// top: calc(50% - 196px) !important;
// 	// left: calc(50% - 86px) !important;

// 	}
#content-second .qnbox .nr1-1tb{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:352px;
	left:752px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .nr1_2input{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:352px;
	left:752px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .exclenrbox {
	   width: 1060px;
       height: 650px;

      position: relative;

	}

#content-second .qnbox .nr1-3tb{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:329px;
	left:38px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1_4input{
	position:absolute;
	width: 71px !important;
    height: 16px !important;
	top:370px;
	left:36px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
.nr1_4 /deep/.el-input__inner{

	width: 77px !important;
    height: 16px !important;

}
#content-second .qnbox .nr1_7input{
	position:absolute;
	width: 76px !important;
    height: 16px !important;
	top:370px;
	left:35px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-6tb{
	position:absolute;
	width: 81px !important;
    height: 16px !important;
	top:329px;
	left:38px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-8tb{
	position:absolute;
	width: 76px !important;
    height: 16px !important;
	top:370px;
	left:35px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-11tb{
	position:absolute;
	width: 67px !important;
    height: 19px !important;
	top:309px;
	left:199px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-12tb{
	position:absolute;
	width: 76px !important;
    height: 371px !important;
	top:310px;
	left:194px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-13tb{
	position:absolute;
	width: 262px !important;
    height: 29px !important;
	top:472px;
	left:232px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-14tb{
	position:absolute;
	width: 265px !important;
    height: 26px !important;
	top:479px;
	left:260px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-15tb{
	position:absolute;
	width: 29px !important;
    height: 15px !important;
	top:386px;
	left:3px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-16tb{
	position:absolute;
	width: 257px !important;
    height: 530px !important;
	top:179px;
	left:203px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-17tb{
	position:absolute;
	width: 250px !important;
    height: 30px !important;
	top:335px;
	left:207px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1-19tb{
	position:absolute;
	width: 74px !important;
    height: 15px !important;
	top:329px;
	left:671px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .qh1-1tb{
	position:absolute;
	width: 74px !important;
    height: 15px !important;
	top:329px;
	left:433px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .qh1-2tb{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:327px;
	left:515px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .qh1-3tb{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:327px;
	left:593px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .qh1_4input{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:327px;
	left:593px;
	cursor: pointer;
	text-align: right;
	background: #CEDBC6;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .pjtb1-1{
	position:absolute;
	width: 74px !important;
    height: 15px !important;
	top:329px;
	left:749px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .pjtb1-2{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:327px;
	left:671px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .qh1_1input{
	position:absolute;
	width: 71px !important;
    height: 16px !important;
	top:328px;
	left:669px;
	cursor: pointer;
	text-align: left;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .pj1_1input{
	position:absolute;
	width: 71px !important;
    height: 16px !important;
	top:328px;
	left:747px;
	cursor: pointer;
	text-align: left;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .zftb1-1{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:327px;
	left:828px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .zftb1-2{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:327px;
	left:356px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .zf1_1input{
	position:absolute;
	width: 71px !important;
    height: 16px !important;
	top:328px;
	left:827px;
	cursor: pointer;
	text-align: left;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .xgtb1-1{
	position:absolute;
	width: 70px !important;
    height: 18px !important;
	top:707px;
	left:129px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .xg1_1input{
	position:absolute;
	width: 70px !important;
    height: 20px !important;
	top:704px;
	left:129px;
	cursor: pointer;
	text-align: center;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .xjtb1-1{
	position:absolute;
	width: 28px !important;
    height: 18px !important;
	top:706px;
	left:214px;
	cursor: pointer;
	text-align: center;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .xjtb1-2{
	position:absolute;
	width: 20px !important;
    height: 22px !important;
	top:705px;
	left:210px;
	cursor: pointer;
	text-align: center;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .zbtb1-1{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:460px;
	left:444px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .zbtb1-2{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:327px;
	left:112px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .zbtb1-3{
	position:absolute;
	width: 71px !important;
    height: 17px !important;
	top:328px;
	left:37px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .zb1_1input{
	position:absolute;
	width: 69px !important;
    height: 15px !important;
	top:329px;
	left:188px;
	cursor: pointer;
	text-align: left;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .xgtb2-1{
	position:absolute;
	width: 69px !important;
    height: 22px !important;
	top:703px;
	left:214px;
	cursor: pointer;
	text-align: right;
	background: #EDC8C8;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .xg2_1input{
	position:absolute;
	width: 69px !important;
    height: 22px !important;
	top:704px;
	left:214px;
	cursor: pointer;
	text-align: center;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .zttb1-1{
	position:absolute;
	width: 11px !important;
    height: 24px !important;
	top:154px;
	left:296px;
	cursor: pointer;
	text-align: right;
	background: #EDC8C8;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .zttb1-2{
	position:absolute;
	width: 278px !important;
    height: 27px !important;
	top:259px;
	left:187px;
	cursor: pointer;
	text-align: right;
	background: #EDC8C8;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .zttb1-3{
	position:absolute;
	width: 266px !important;
    height: 20px !important;
	top:264px;
	left:187px;
	cursor: pointer;
	text-align: right;
	background: #EDC8C8;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .jztb1-1{
	position:absolute;
	width: 22px !important;
    height: 20px !important;
	top:186px;
	left:478px;
	cursor: pointer;
	text-align: right;
	background: #EDC8C8;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .jztb1-2{
	position:absolute;
	width: 22px !important;
    height: 22px !important;
	top:184px;
	left:477px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .kxtb1-1{
	position:absolute;
	width: 30px !important;
    height: 21px !important;
	top:184px;
	left:262px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .kxtb1-2{
	position:absolute;
	width: 31px !important;
    height: 22px !important;
	top:181px;
	left:260px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .kxtb1-3{
	position:absolute;
	width: 188px !important;
    height: 24px !important;
	top:242px;
	left:261px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .kxtb1-4{
	position:absolute;
	width: 188px !important;
    height: 26px !important;
	top:240px;
	left:262px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .tatb1-1{
	position:absolute;
	width: 72px !important;
    height: 18px !important;
	top:269px;
	left:38px;
	cursor: pointer;
	// cursor:move;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-third .qnbox .tatb1-2{
	position:absolute;
	width: 2px !important;
    height: 389px !important;
	top:263px;
	left:113px;
	cursor:move;
	text-align: right;
  z-index: 9;

}
//
#content-third .qnbox .dbclick{
  position:absolute;
  width: 60px !important;
  height: 40px !important;
  top:255px;
  left:85px;
  cursor:move;
  text-align: center;
}
#content-third .qnbox .jchbtb1-1{
	position:absolute;
	width: 24px !important;
    height: 21px !important;
	top:156px;
	left:389px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-2{
	position:absolute;
	width: 23px !important;
    height: 23px !important;
	top:155px;
	left:387px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-4{
	position:absolute;
	width: 20px !important;
    height: 22px !important;
	top:184px;
	left:185px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-5{
	position:absolute;
	width: 20px !important;
    height: 22px !important;
	top:184px;
	left:184px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-6{
	position:absolute;
	width: 64px !important;
    height: 47px !important;
	top:159px;
	left:592px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-7{
	position:absolute;
	width: 70px !important;
    height: 47px !important;
	top:158px;
	left:588px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-8{
	position:absolute;
	width: 30px !important;
    height: 28px !important;
	top:183px;
	left:333px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-9{
	position:absolute;
	width: 36px !important;
    height: 24px !important;
	top:183px;
	left:330px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-10{
	position:absolute;
	width: 14px !important;
    height: 15px !important;
	top:287px;
	left:489px;
	cursor:pointer;
	text-align: right;

}
#content-third .qnbox .jchbtb1-11{
	position:absolute;
	width: 12px !important;
    height: 9px !important;
	top:292px;
	left:490px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .yshhtb1-1{
	position:absolute;
	width: 20px !important;
    height: 23px !important;
	top:184px;
	left:369px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .yshhtb1-2{
	position:absolute;
	width: 20px !important;
    height: 23px !important;
	top:184px;
	left:369px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .yshhtb1-3{
	position:absolute;
	width: 56px !important;
    height: 50px !important;
	top:155px;
	left:662px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .yshhtb1-4{
	position:absolute;
	width: 56px !important;
    height: 50px !important;
	top:156px;
	left:661px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .djtb1-1{
	position:absolute;
	width: 63px !important;
    height: 49px !important;
	top:156px;
	left:839px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .djtb1-2{
	position:absolute;
	width: 63px !important;
    height: 49px !important;
	top:156px;
	left:839px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .djtb1-3{
	position:absolute;
	width: 146px !important;
    height: 24px !important;
	top:216px;
	left:839px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .djtb1-4{
	position:absolute;
	width: 146px !important;
    height: 24px !important;
	top:216px;
	left:839px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-1{
	position:absolute;
	width: 12px !important;
    height: 19px !important;
	top:158px;
	left:863px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-2{
	position:absolute;
	width: 12px !important;
    height: 19px !important;
	top:158px;
	left:863px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-3{
	position:absolute;
	width: 210px !important;
    height: 25px !important;
	top:730px;
	left:738px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-4{
	position:absolute;
	width: 202px !important;
    height: 19px !important;
	top:727px;
	left:738px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-5{
	position:absolute;
	width: 40px !important;
    height: 29px !important;
	top:246px;
	left:323px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-6{
	position:absolute;
	width: 67px !important;
    height: 32pxpx !important;
	top:277px;
	left:522px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-7{
	position:absolute;
	width: 12px !important;
    height: 7px !important;
	top:293px;
	left:570px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .xstb1-8{
	position:absolute;
	width: 71px !important;
    height: 27px !important;
	top:644px;
	left:605px;
	cursor:pointer;
	// text-align: right;

}#content-third .qnbox .xstb1-9{
	position:absolute;
	width: 71px !important;
    height: 28px !important;
	top:645px;
	left:605px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .zbbltb1-1{
	position:absolute;
	width: 12px !important;
    height: 19px !important;
	top:158px;
	left:863px;
	cursor:pointer;
	// text-align: right;

}
#content-third .qnbox .zbbltb1-2{
position:absolute;
	width: 12px !important;
    height: 19px !important;
	top:158px;
	left:863px;
	cursor:pointer;
	// text-align: right;
}
#content-third .qnbox .zbbltb1-3{
position:absolute;
	width: 210px !important;
    height: 51px !important;
	top:537px;
	left:735px;
	cursor:pointer;
	// text-align: right;
}
#content-third .qnbox .zbbltb1-4{
position:absolute;
	width: 203px !important;
    height: 42px !important;
	top:537px;
	left:735px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bctb1-1{
position:absolute;
	width: 133px !important;
    height: 30px !important;
	top:302px;
	left:108px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bc1_1input{
position:absolute;
	width: 67px !important;
    height: 35px !important;
	top:382px;
	left:869px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bctb1-2{
position:absolute;
	width: 137px !important;
    height: 33px !important;
	top:302px;
	left:111px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bctb1-3{
position:absolute;
	width: 157px !important;
    height: 45px !important;
	top:297px;
	left:790px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bctb1-4{
position:absolute;
	width: 247px !important;
    height: 57px !important;
	top:291px;
	left:786px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bctb1-5{
	position:absolute;
	width: 93px !important;
    height: 22px !important;
	top:627px;
	left:377px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bctb1-6{
	position:absolute;
	width: 97px !important;
    height: 24px !important;
	top:627px;
	left:376px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bc_2input{
	position:absolute;
	width: 550px !important;
    height: 22px !important;
	top:627px;
	left:376px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .bctb1-7{
	position:absolute;
	width: 88px !important;
    height: 28px !important;
	top:691px;
	left:850px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .lc1-1{
	position:absolute;
	width: 245px !important;
    height: 339px !important;
	top:97px;
	left:394px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .lctb1-1{
	position:absolute;
	width: 235px !important;
    height: 30px !important;
	top:126px;
	left:397px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .lctb1-2{
	position:absolute;
	width: 235px !important;
    height: 24px !important;
	top:126px;
	left:397px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .lctb1-3{
	position:absolute;
	width: 113px !important;
    height: 33px !important;
	top:228px;
	left:116px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .lctb1-4{
	position:absolute;
	width: 113px !important;
    height: 33px !important;
	top:228px;
	left:116px;
	cursor:pointer;
	// text-align: right;
}
#content-four .qnbox .lctb1-5{
	position:absolute;
	width: 86px !important;
    height: 25px !important;
	top:623px;
	left:852px;
	cursor:pointer;
	// text-align: right;
}
#content-five .qnbox .fstb1-1{
	position:absolute;
	width: 21px !important;
    height: 20px !important;
	top:86px;
	left:450px;
	cursor:pointer;
	// text-align: right;
}
#content-five .qnbox .fstb1-2{
	position:absolute;
	width: 69px !important;
    height: 90px !important;
	top:266px;
	left:63px;
	cursor:pointer;
	// text-align: right;
}
#content-five .qnbox .fstb1-0{
	position:absolute;
	width: 15px !important;
    height: 14px !important;
	top:91px;
	left:452px;
	cursor:pointer;
	// text-align: right;
}
#content-five .qnbox .fstb1-3{
	position:absolute;
	width: 70px !important;
    height: 26px !important;
	top:668px;
	left:796px;
	cursor:pointer;
	// text-align: right;
}
#content-six .qnbox .zttb1-1{
	position:absolute;
	width: 11px !important;
    height: 24px !important;
	top:154px;
	left:278px;
	cursor: pointer;
	text-align: right;

}
#content-six .qnbox .wdzttb1-2{
	position:absolute;
	width: 12px !important;
    height: 21px !important;
	top:156px;
	left:280px;
	cursor: pointer;
	text-align: right;

}
#content-six .qnbox .wdzttb1-3{
	position:absolute;
	width: 276px !important;
    height: 28px !important;
	top:262px;
	left:175px;
	cursor: pointer;
	text-align: right;

}
#content-six .qnbox .wdzttb1-4{
	position:absolute;
	width: 262px !important;
    height: 20px !important;
	top:263px;
	left:179px;
	cursor: pointer;
	text-align: right;

}
#content-six .qnbox .wdzttb1-5{
	position:absolute;
	width: 11px !important;
    height: 24px !important;
	top:154px;
	left:362px;
	cursor: pointer;



}
#content-six .qnbox .wdzttb1-6{
	position:absolute;
	width: 12px !important;
    height: 22px !important;
	top:156px;
	left:363px;
	cursor: pointer;
	text-align: right;

}
#content-six .qnbox .wdzttb1-7{
	position:absolute;
	width: 47px !important;
    height: 23px !important;
	top:414px;
	left:295px;
	cursor: pointer;


}
#content-six .qnbox .wdzttb1-8{
	position:absolute;
	width: 63px !important;
    height: 22px !important;
	top:419px;
	left:297px;
	cursor: pointer;


}
#content-six .qnbox .wdhjtb1-1{
	position:absolute;
	width: 37px !important;
    height: 20px !important;
	top:186px;
	left:642px;
	cursor: pointer;


}
#content-six .qnbox .wdhjtb1-2{
	position:absolute;
	width: 33px !important;
    height: 19px !important;
	top:185px;
	left:648px;
	cursor: pointer;


}
#content-six .qnbox .wdhjtb1-3{
	position:absolute;
	width: 156px !important;
    height: 30px !important;
	top:235px;
	left:649px;
	cursor: pointer;


}
#content-six .qnbox .wdhjtb1-3{
	position:absolute;
	width: 156px !important;
    height: 30px !important;
	top:235px;
	left:649px;
	cursor: pointer;


}
#content-six .qnbox .wdhjtb1-4{
	position:absolute;
	width: 152px !important;
    height: 24px !important;
	top:240px;
	left:652px;
	cursor: pointer;
}
#content-six .qnbox .wdsjtb1-1{
	position:absolute;
	width: 217.7px !important;
    height: 457.1px !important;
	top:240px;
	left:652px;

}
#content-six .qnbox .wdsjtb1-1-1{
	position:absolute;
	width: 213.7px !important;
    height:25px !important;
	top:524px;
	left:652px;
	cursor: pointer;
}
#content-six .qnbox .wdsjtb1-2{
	position:absolute;
	width: 327.6px !important;
    height:417.2px !important;
	top:309px;
	left:394px;

}
#content-six .qnbox .wdsjtb1-3{
	position:absolute;
	width: 65px !important;
    height:17px !important;
	top:466px;
	left:561px;
	cursor: pointer;

}
#content-six .qnbox .wdsjtb1-4{
	position:absolute;
	width: 59px !important;
    height:17px !important;
	top:502px;
	left:560px;
	cursor: pointer;

}
#content-six .qnbox .wdsjtb1-5{
	position:absolute;
	width: 59px !important;
    height:15px !important;
	top:502px;
	left:560px;
	cursor: pointer;

}
#content-six .qnbox .wdsjtb1-6{
	position:absolute;
	width: 63.6px !important;
    height:21px !important;
	top:696px;
	left:576px;
	cursor: pointer;

}
#content-six .qnbox .jchbtb1-4{
	position:absolute;
	width: 20px !important;
    height: 22px !important;
	top:185px;
	left:174px;
	cursor:pointer;
	text-align: right;
}
#content-six .qnbox .jchbtb1-5{
	position:absolute;
	width: 21px !important;
    height: 22px !important;
	top:184px;
	left:174px;
	cursor:pointer;
	text-align: right;

}
#content-six .qnbox .jztb1-1{
	position:absolute;
	width: 22px !important;
    height: 22px !important;
	top:184px;
	left:532px;
	cursor: pointer;
	text-align: right;
	background: #EDC8C8;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-six .qnbox .jztb1-2{
	position:absolute;
	width: 23px !important;
    height: 25px !important;
	top:182px;
	left:532px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-six .qnbox .wdystb1-1{
	position:absolute;
	width: 30px !important;
    height: 21px !important;
	top:184px;
	left:423px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-six .qnbox .wdystb1-2{
	position:absolute;
	width: 38px !important;
    height: 29px !important;
	top:181px;
	left:418px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-six .qnbox .wdystb1-3{
	position:absolute;
	width: 17px !important;
    height: 16px !important;
	top:397px;
	left:443px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-six .qnbox .wdystb1-4{
	position:absolute;
	width: 11px !important;
    height: 9px !important;
	top:402px;
	left:447px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-six .qnbox .wdtxtb1-1{
	position:absolute;
	width: 29px !important;
    height: 21px !important;
	top:184px;
	left:387px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-six .qnbox .wdtxtb1-2{
	position:absolute;
	width: 29px !important;
    height: 20px !important;
	top:184px;
	left:387px;
	cursor: pointer;
	text-align: right;

	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
</style>



// WEBPACK FOOTER //
// ./src/page/excel/newexcel.vue